//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import axios from "axios";
export class Client {
    instance;
    baseUrl;
    jsonParseReviver = undefined;
    constructor(baseUrl, instance) {
        this.instance = instance ? instance : axios.create();
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }
    /**
     * Fetch a single area
     * @param areaID The id of an area
     * @return Success
     */
    areasGET(areaID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Areas/{areaID}";
        if (areaID === undefined || areaID === null)
            throw new Error("The parameter 'areaID' must be defined.");
        url_ = url_.replace("{areaID}", encodeURIComponent("" + areaID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAreasGET(_response);
        });
    }
    processAreasGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all areas
     * @param subscriptionID (optional) If set, return only areas belonging the that subscription
     * @param costumerID (optional) If set, return only areas belonging the that customer
     * @return Success
     */
    areasGET2(subscriptionID, costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Areas?";
        if (subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' cannot be null.");
        else if (subscriptionID !== undefined)
            url_ += "subscriptionID=" + encodeURIComponent("" + subscriptionID) + "&";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAreasGET2(_response);
        });
    }
    processAreasGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    areaPATCH(customerID, areaID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Areas/Customer/{customerID}/Area/{areaID}";
        if (customerID === undefined || customerID === null)
            throw new Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        if (areaID === undefined || areaID === null)
            throw new Error("The parameter 'areaID' must be defined.");
        url_ = url_.replace("{areaID}", encodeURIComponent("" + areaID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAreaPATCH(_response);
        });
    }
    processAreaPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    areasPATCH(customerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Areas/Customer/{customerID}/Areas";
        if (customerID === undefined || customerID === null)
            throw new Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAreasPATCH(_response);
        });
    }
    processAreasPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Authenticate a user
     * @param stealSession (optional) If set, the current session is stolen.
     * @param body (optional) The authentication information used to authenticate the user
     * @return Success
     */
    authenticate(stealSession, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/authenticate?";
        if (stealSession === null)
            throw new Error("The parameter 'stealSession' cannot be null.");
        else if (stealSession !== undefined)
            url_ += "stealSession=" + encodeURIComponent("" + stealSession) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAuthenticate(_response);
        });
    }
    processAuthenticate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfAuthenticateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Refresh a JWT token
     * @param body (optional)
     * @return Success
     */
    refreshToken(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/refresh-token";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processRefreshToken(_response);
        });
    }
    processRefreshToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfAuthenticateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Revoke your refresh token
     * @param body (optional)
     * @return Success - your token has been revoked
     */
    revokeToken(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/revoke-token";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processRevokeToken(_response);
        });
    }
    processRevokeToken(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all cars
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param subscriptionID (optional) If set, the endpoint returns only cars belonging to the specific subscription
     * @return Success
     */
    carsGET(pageNumber, pageSize, sortOrderAsc, sortBy, subscriptionID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Cars?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' cannot be null.");
        else if (subscriptionID !== undefined)
            url_ += "subscriptionID=" + encodeURIComponent("" + subscriptionID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCarsGET(_response);
        });
    }
    processCarsGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a single car
     * @param carId The id of the car
     * @return Success
     */
    carsGET2(carId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Cars/{CarId}";
        if (carId === undefined || carId === null)
            throw new Error("The parameter 'carId' must be defined.");
        url_ = url_.replace("{CarId}", encodeURIComponent("" + carId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCarsGET2(_response);
        });
    }
    processCarsGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a car
     * @param carID The id of the car
     * @param body (optional) The object replacing the existing car
     * @return Success
     */
    carsPUT(carID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Cars/{CarID}";
        if (carID === undefined || carID === null)
            throw new Error("The parameter 'carID' must be defined.");
        url_ = url_.replace("{CarID}", encodeURIComponent("" + carID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCarsPUT(_response);
        });
    }
    processCarsPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    accessLevels(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/accessLevels";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAccessLevels(_response);
        });
    }
    processAccessLevels(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfAccessLevelResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all subscriptionTypes
     * @param costumerID (optional) If set, return subscriptionTypes belonging to that customer
     * @return Success
     */
    subscriptiontypesGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/subscriptiontypes?";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptiontypesGET(_response);
        });
    }
    processSubscriptiontypesGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a subscriptionType
     * @param costumerID The customer owning the subscriptionType
     * @param body (optional) The subscriptionType to be added
     * @return Success
     */
    subscriptiontypesPOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/subscriptiontypes/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptiontypesPOST(_response);
        });
    }
    processSubscriptiontypesPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a subscriptionType
     * @param subscriptionTypeID The id of the subscriptionType to update
     * @param costumerID The customer owning the subscriptionType
     * @param body (optional) The new subscriptionType object
     * @return Success
     */
    subscriptiontypesPUT(subscriptionTypeID, costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/subscriptiontypes/{subscriptionTypeID}/{costumerID}";
        if (subscriptionTypeID === undefined || subscriptionTypeID === null)
            throw new Error("The parameter 'subscriptionTypeID' must be defined.");
        url_ = url_.replace("{subscriptionTypeID}", encodeURIComponent("" + subscriptionTypeID));
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptiontypesPUT(_response);
        });
    }
    processSubscriptiontypesPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    subscriptiontypesDELETE(subscriptionTypeID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/subscriptiontypes/{subscriptionTypeID}";
        if (subscriptionTypeID === undefined || subscriptionTypeID === null)
            throw new Error("The parameter 'subscriptionTypeID' must be defined.");
        url_ = url_.replace("{subscriptionTypeID}", encodeURIComponent("" + subscriptionTypeID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptiontypesDELETE(_response);
        });
    }
    processSubscriptiontypesDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            let result204 = null;
            let resultData204 = _responseText;
            result204 = NoContentResult.fromJS(resultData204);
            return Promise.resolve(result204);
        }
        else if (status === 400) {
            const _responseText = response.data;
            let result400 = null;
            let resultData400 = _responseText;
            result400 = BadRequestResult.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        }
        else if (status === 404) {
            const _responseText = response.data;
            let result404 = null;
            let resultData404 = _responseText;
            result404 = NotFoundResult.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a list of modes
     * @return Success
     */
    modes(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/modes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processModes(_response);
        });
    }
    processModes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfModeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a list of emailTemplateTypes
     * @return Success
     */
    emailTemplateTypes(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/emailTemplateTypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailTemplateTypes(_response);
        });
    }
    processEmailTemplateTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfEmailTemplateTypesAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch emailSendingStates
     * @return Success
     */
    emailSendingState(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/emailSendingState";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailSendingState(_response);
        });
    }
    processEmailSendingState(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfEmailSendingStateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch maskingActions
     * @return Success
     */
    maskingAction(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/maskingAction";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMaskingAction(_response);
        });
    }
    processMaskingAction(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfMaskingActionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch maskableEntities
     * @return Success
     */
    maskableEntities(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/maskableEntities";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMaskableEntities(_response);
        });
    }
    processMaskableEntities(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfMaskableEntityResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetches parkingtypes from PRS. This is a proxy endpoint
     * @return Success
     */
    parkingTypes(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/parkingTypes";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkingTypes(_response);
        });
    }
    processParkingTypes(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfIEnumerable_1OfOfParkingTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetches the available parkingSources from PRS. This is a proxy endpoint
     * @return Success
     */
    parkingSystems(costumerId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Constants/parkingSystems/{costumerId}";
        if (costumerId === undefined || costumerId === null)
            throw new Error("The parameter 'costumerId' must be defined.");
        url_ = url_.replace("{costumerId}", encodeURIComponent("" + costumerId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkingSystems(_response);
        });
    }
    processParkingSystems(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfIEnumerable_1OfOfParkingSystemResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all customers
     * @return Success
     */
    costumersGET(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCostumersGET(_response);
        });
    }
    processCostumersGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a new customer
     * @param body (optional) The customer to be added
     * @return Success
     */
    costumersPOST(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCostumersPOST(_response);
        });
    }
    processCostumersPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a single customer
     * @param costumerID The id of the customer
     * @return Success
     */
    costumersGET2(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCostumersGET2(_response);
        });
    }
    processCostumersGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a costumer
     * @param costumerID The id of the customer
     * @param body (optional) The updates applied to the customer
     * @return Success
     */
    costumersPATCH(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{CostumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCostumersPATCH(_response);
        });
    }
    processCostumersPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a sensitive data configuration
     * @param costumerID The customer owning the configuration
     * @param body (optional) The configuration to be added
     * @return Success
     */
    maskingPOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/masking";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMaskingPOST(_response);
        });
    }
    processMaskingPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a list of masking configurations
     * @param costumerID The costumer owning the configurations
     * @return Success
     */
    maskingGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/masking";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMaskingGET(_response);
        });
    }
    processMaskingGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a sensitive data configuration
     * @param costumerID The costumer owning the configuration
     * @param body (optional) The updated configuration
     * @return Success
     */
    maskingPUT(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/masking";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMaskingPUT(_response);
        });
    }
    processMaskingPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch features
     * @param costumerID The customer owning the features
     * @return Success
     */
    featuresGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/features";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processFeaturesGET(_response);
        });
    }
    processFeaturesGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfFeatureToggleResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Toggle a feature
     * @param costumerID The customer owning the feature
     * @param featureID The id of the feature
     * @param body (optional) The updated feature toggle
     * @return Success
     */
    featuresPUT(costumerID, featureID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/features/{featureID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (featureID === undefined || featureID === null)
            throw new Error("The parameter 'featureID' must be defined.");
        url_ = url_.replace("{featureID}", encodeURIComponent("" + featureID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processFeaturesPUT(_response);
        });
    }
    processFeaturesPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfFeatureToggleResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Get customers logo
     * @param costumerID The customer owning the feature
     * @return Success
     */
    logoGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/logo";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processLogoGET(_response);
        });
    }
    processLogoGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Adds customers logo
     * @param costumerID The customer owning the feature
     * @param body (optional)
     * @return Success
     */
    logoPOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Costumers/{costumerID}/logo";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processLogoPOST(_response);
        });
    }
    processLogoPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch enqueued emails
     * @param costumerID The customer owning the pending emails
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param search (optional) Used to query the list of pending email
     * @return Success
     */
    pendingGET(costumerID, pageNumber, pageSize, sortOrderAsc, sortBy, search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Emails/pending/{CostumerID}?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{CostumerID}", encodeURIComponent("" + costumerID));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPendingGET(_response);
        });
    }
    processPendingGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfMailResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Remove an email from the queue
     * @param costumerID The customer owning the email
     * @param mailID The id of the email to be deleted
     * @return Success
     */
    pendingDELETE(costumerID, mailID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Emails/pending/{costumerID}/{mailID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (mailID === undefined || mailID === null)
            throw new Error("The parameter 'mailID' must be defined.");
        url_ = url_.replace("{mailID}", encodeURIComponent("" + mailID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPendingDELETE(_response);
        });
    }
    processPendingDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Enqueue a QR Email
     * @param subscriptionID The receiver of the email
     * @return Success
     */
    qRCodePATCH(subscriptionID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Emails/{SubscriptionID}/QRCode";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{SubscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processQRCodePATCH(_response);
        });
    }
    processQRCodePATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch email configurations
     * @param costumerID The customer owning the configurations
     * @param emailTemplateTypeID (optional) If set, the endpoint only returns configurations for that specific templateType
     * @return Success
     */
    configurationsGET(costumerID, emailTemplateTypeID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Emails/{costumerID}/configurations?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (emailTemplateTypeID === null)
            throw new Error("The parameter 'emailTemplateTypeID' cannot be null.");
        else if (emailTemplateTypeID !== undefined)
            url_ += "emailTemplateTypeID=" + encodeURIComponent("" + emailTemplateTypeID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processConfigurationsGET(_response);
        });
    }
    processConfigurationsGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfEmailConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add an email configuration
     * @param body (optional)
     * @return Success
     */
    configurationsPOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Emails/{costumerID}/configurations";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processConfigurationsPOST(_response);
        });
    }
    processConfigurationsPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfEmailConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetches imported parkings.
     * @param costumerID The customer owning the parkings
     * @param from All parkings updated since this datetime is returned
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @return Success
     */
    parkings(costumerID, from, pageNumber, pageSize, sortOrderAsc, sortBy, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/{from}?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (from === undefined || from === null)
            throw new Error("The parameter 'from' must be defined.");
        url_ = url_.replace("{from}", encodeURIComponent("" + from));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkings(_response);
        });
    }
    processParkings(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfParkingResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Look up a unterminated vehicle in PRS
     * @param costumerID The customer owning the parking
     * @param areaID The specific area to search for the parking at
     * @param vehicleIdent The identifier of the vehicle being looked up
     * @return Success
     */
    parkings2(costumerID, areaID, vehicleIdent, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/{areaID}/{vehicleIdent}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (areaID === undefined || areaID === null)
            throw new Error("The parameter 'areaID' must be defined.");
        url_ = url_.replace("{areaID}", encodeURIComponent("" + areaID));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkings2(_response);
        });
    }
    processParkings2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfParkingResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch parking periods from PRS
     * @param parkingRightType (optional) If omitted, it defaults to "FreeFlow"
     * @param parkingRightSource (optional) If omitted, it default to "PRS", "EasyParkCameraPark"
     * @param body (optional)
     * @return Success
     */
    statistics(costumerID, intervalBegin, intervalEnd, parkingRightType, parkingRightSource, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/statistics?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (intervalBegin === undefined || intervalBegin === null)
            throw new Error("The parameter 'intervalBegin' must be defined and cannot be null.");
        else
            url_ += "intervalBegin=" + encodeURIComponent("" + intervalBegin) + "&";
        if (intervalEnd === undefined || intervalEnd === null)
            throw new Error("The parameter 'intervalEnd' must be defined and cannot be null.");
        else
            url_ += "intervalEnd=" + encodeURIComponent("" + intervalEnd) + "&";
        if (parkingRightType === null)
            throw new Error("The parameter 'parkingRightType' cannot be null.");
        else if (parkingRightType !== undefined)
            parkingRightType &&
                parkingRightType.forEach(item => {
                    url_ += "parkingRightType=" + encodeURIComponent("" + item) + "&";
                });
        if (parkingRightSource === null)
            throw new Error("The parameter 'parkingRightSource' cannot be null.");
        else if (parkingRightSource !== undefined)
            parkingRightSource &&
                parkingRightSource.forEach(item => {
                    url_ += "parkingRightSource=" + encodeURIComponent("" + item) + "&";
                });
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processStatistics(_response);
        });
    }
    processStatistics(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfPeriodsAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch parking exits from PRS
     * @param parkingRightType (optional) If omitted, it defaults to "FreeFlow"
     * @param parkingRightSource (optional) If omitted, it default to "PRS", "EasyParkCameraPark"
     * @param body (optional)
     * @return Success
     */
    exists(costumerID, intervalBegin, intervalEnd, parkingRightType, parkingRightSource, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/exists?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (intervalBegin === undefined || intervalBegin === null)
            throw new Error("The parameter 'intervalBegin' must be defined and cannot be null.");
        else
            url_ += "intervalBegin=" + encodeURIComponent("" + intervalBegin) + "&";
        if (intervalEnd === undefined || intervalEnd === null)
            throw new Error("The parameter 'intervalEnd' must be defined and cannot be null.");
        else
            url_ += "intervalEnd=" + encodeURIComponent("" + intervalEnd) + "&";
        if (parkingRightType === null)
            throw new Error("The parameter 'parkingRightType' cannot be null.");
        else if (parkingRightType !== undefined)
            parkingRightType &&
                parkingRightType.forEach(item => {
                    url_ += "parkingRightType=" + encodeURIComponent("" + item) + "&";
                });
        if (parkingRightSource === null)
            throw new Error("The parameter 'parkingRightSource' cannot be null.");
        else if (parkingRightSource !== undefined)
            parkingRightSource &&
                parkingRightSource.forEach(item => {
                    url_ += "parkingRightSource=" + encodeURIComponent("" + item) + "&";
                });
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processExists(_response);
        });
    }
    processExists(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParkingExistsContainerAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch parking occupancy from PRS
     * @param parkingRightType (optional) If omitted, it defaults to "FreeFlow"
     * @param parkingRightSource (optional) If omitted, it default to "PRS", "EasyParkCameraPark"
     * @param body (optional)
     * @return Success
     */
    occupancy(costumerID, time, parkingRightType, parkingRightSource, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/occupancy?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (time === undefined || time === null)
            throw new Error("The parameter 'time' must be defined and cannot be null.");
        else
            url_ += "time=" + encodeURIComponent("" + time) + "&";
        if (parkingRightType === null)
            throw new Error("The parameter 'parkingRightType' cannot be null.");
        else if (parkingRightType !== undefined)
            parkingRightType &&
                parkingRightType.forEach(item => {
                    url_ += "parkingRightType=" + encodeURIComponent("" + item) + "&";
                });
        if (parkingRightSource === null)
            throw new Error("The parameter 'parkingRightSource' cannot be null.");
        else if (parkingRightSource !== undefined)
            parkingRightSource &&
                parkingRightSource.forEach(item => {
                    url_ += "parkingRightSource=" + encodeURIComponent("" + item) + "&";
                });
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processOccupancy(_response);
        });
    }
    processOccupancy(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParkingOccupancyContainerAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Export parkings from PRS
     * @param parkingRightType (optional) If omitted, it defaults to "FreeFlow"
     * @param parkingRightSource (optional) If omitted, it default to "PRS", "EasyParkCameraPark"
     * @param body (optional)
     * @return Success
     */
    export(costumerID, intervalBegin, intervalEnd, parkingRightType, parkingRightSource, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/export?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (intervalBegin === undefined || intervalBegin === null)
            throw new Error("The parameter 'intervalBegin' must be defined and cannot be null.");
        else
            url_ += "intervalBegin=" + encodeURIComponent("" + intervalBegin) + "&";
        if (intervalEnd === undefined || intervalEnd === null)
            throw new Error("The parameter 'intervalEnd' must be defined and cannot be null.");
        else
            url_ += "intervalEnd=" + encodeURIComponent("" + intervalEnd) + "&";
        if (parkingRightType === null)
            throw new Error("The parameter 'parkingRightType' cannot be null.");
        else if (parkingRightType !== undefined)
            parkingRightType &&
                parkingRightType.forEach(item => {
                    url_ += "parkingRightType=" + encodeURIComponent("" + item) + "&";
                });
        if (parkingRightSource === null)
            throw new Error("The parameter 'parkingRightSource' cannot be null.");
        else if (parkingRightSource !== undefined)
            parkingRightSource &&
                parkingRightSource.forEach(item => {
                    url_ += "parkingRightSource=" + encodeURIComponent("" + item) + "&";
                });
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processExport(_response);
        });
    }
    processExport(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers
                ? response.headers["content-disposition"]
                : undefined;
            let fileNameMatch = contentDisposition
                ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
                : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1
                ? fileNameMatch[3] || fileNameMatch[2]
                : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition
                    ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
                    : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({
                fileName: fileName,
                status: status,
                data: new Blob([response.data], { type: response.headers["content-type"] }),
                headers: _headers,
            });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Gets a parking tagger instance for a given costumer
     * @param costumerID Identification of the costumer
     * @return Success
     */
    parkingTaggerGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/parkingTagger";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkingTaggerGET(_response);
        });
    }
    processParkingTaggerGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParkingTaggerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Updates a parking tagger instance
     * @param costumerID Identification of the costumer
     * @param body (optional) The parking tagger with updated values
     * @return Success
     */
    parkingTaggerPUT(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Parkings/{costumerID}/parkingTagger";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkingTaggerPUT(_response);
        });
    }
    processParkingTaggerPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParkingTaggerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Ping the server
     * @return Success
     */
    ping(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Server/ping";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPing(_response);
        });
    }
    processPing(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfPingAndUtilsAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetches all chart data related to the statistics page
     * @param body (optional)
     * @return Success
     */
    chartData(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Statistics/{costumerID}/chartData";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processChartData(_response);
        });
    }
    processChartData(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfStatisticsResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param searchStart (optional)
     * @param searchEnd (optional)
     * @param minutesPerInterval (optional)
     * @param numberOfIntervals (optional)
     * @param skipIntervals (optional)
     * @param from (optional)
     * @param to (optional)
     * @param timeZone (optional)
     * @return Success
     */
    chartDataTest(searchStart, searchEnd, minutesPerInterval, numberOfIntervals, skipIntervals, from, to, timeZone, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Statistics/chartDataTest?";
        if (searchStart === null)
            throw new Error("The parameter 'searchStart' cannot be null.");
        else if (searchStart !== undefined)
            url_ += "searchStart=" + encodeURIComponent("" + searchStart) + "&";
        if (searchEnd === null)
            throw new Error("The parameter 'searchEnd' cannot be null.");
        else if (searchEnd !== undefined)
            url_ += "searchEnd=" + encodeURIComponent("" + searchEnd) + "&";
        if (minutesPerInterval === null)
            throw new Error("The parameter 'minutesPerInterval' cannot be null.");
        else if (minutesPerInterval !== undefined)
            url_ += "minutesPerInterval=" + encodeURIComponent("" + minutesPerInterval) + "&";
        if (numberOfIntervals === null)
            throw new Error("The parameter 'numberOfIntervals' cannot be null.");
        else if (numberOfIntervals !== undefined)
            url_ += "numberOfIntervals=" + encodeURIComponent("" + numberOfIntervals) + "&";
        if (skipIntervals === null)
            throw new Error("The parameter 'skipIntervals' cannot be null.");
        else if (skipIntervals !== undefined)
            url_ += "skipIntervals=" + encodeURIComponent("" + skipIntervals) + "&";
        if (from === null)
            throw new Error("The parameter 'from' cannot be null.");
        else if (from !== undefined)
            from &&
                from.forEach(item => {
                    url_ += "from=" + encodeURIComponent("" + item) + "&";
                });
        if (to === null)
            throw new Error("The parameter 'to' cannot be null.");
        else if (to !== undefined)
            to &&
                to.forEach(item => {
                    url_ += "to=" + encodeURIComponent("" + item) + "&";
                });
        if (timeZone === null)
            throw new Error("The parameter 'timeZone' cannot be null.");
        else if (timeZone !== undefined)
            url_ += "timeZone=" + encodeURIComponent("" + timeZone) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processChartDataTest(_response);
        });
    }
    processChartDataTest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfStatisticsResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all subscribers
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param search (optional) A string used as a search query
     * @param includeInactive (optional) If set, also include inactive subscribers
     * @return Success
     */
    subscribersGET(pageNumber, pageSize, sortOrderAsc, sortBy, search, includeInactive, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscribersGET(_response);
        });
    }
    processSubscribersGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a single subscriber
     * @param subscriberId The id of the subscriber
     * @return Success
     */
    subscribersGET2(subscriberId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/{SubscriberId}";
        if (subscriberId === undefined || subscriberId === null)
            throw new Error("The parameter 'subscriberId' must be defined.");
        url_ = url_.replace("{SubscriberId}", encodeURIComponent("" + subscriberId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscribersGET2(_response);
        });
    }
    processSubscribersGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a subscriber
     * @param costumerID (optional) The customer set to own the subscriber
     * @param body (optional)
     * @return Success
     */
    company(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/Company?";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCompany(_response);
        });
    }
    processCompany(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData201);
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a subscriber person
     * @param body (optional)
     * @return Success
     */
    person(body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/Person";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPerson(_response);
        });
    }
    processPerson(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData201);
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a subscriber
     * @param subscriberID The id of the subscriber being updated
     * @param costumerID (optional) Customer owning the subscriber
     * @param isPerson (optional) If true, the subscriber being updated is of the type Person, else Company
     * @param body (optional) The updated data of the subscriber
     * @return Success
     */
    subscribersPUT(subscriberID, costumerID, isPerson, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/{subscriberID}?";
        if (subscriberID === undefined || subscriberID === null)
            throw new Error("The parameter 'subscriberID' must be defined.");
        url_ = url_.replace("{subscriberID}", encodeURIComponent("" + subscriberID));
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        if (isPerson === null)
            throw new Error("The parameter 'isPerson' cannot be null.");
        else if (isPerson !== undefined)
            url_ += "isPerson=" + encodeURIComponent("" + isPerson) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscribersPUT(_response);
        });
    }
    processSubscribersPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a subscriber
     * @return Success
     */
    subscribersDELETE(subscriberID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/{SubscriberID}";
        if (subscriberID === undefined || subscriberID === null)
            throw new Error("The parameter 'subscriberID' must be defined.");
        url_ = url_.replace("{SubscriberID}", encodeURIComponent("" + subscriberID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscribersDELETE(_response);
        });
    }
    processSubscribersDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Activate a subscriber
     * @param active (optional)
     * @return Success
     */
    activate(subscriberID, active, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/{SubscriberID}/activate?";
        if (subscriberID === undefined || subscriberID === null)
            throw new Error("The parameter 'subscriberID' must be defined.");
        url_ = url_.replace("{SubscriberID}", encodeURIComponent("" + subscriberID));
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processActivate(_response);
        });
    }
    processActivate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a subscription to the specified subsciber
     * @param subscriberId The subscriber owning the subscription
     * @param emailTemplateID (optional) A welcome email template, used instead of the default configured template
     * @param vehicleIdent (optional)
     * @param costumerID (optional) The customer owning the subscriber
     * @param body (optional) The subscription to be added
     * @return Success
     */
    subscription(subscriberId, emailTemplateID, vehicleIdent, costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/{SubscriberId}/Subscription?";
        if (subscriberId === undefined || subscriberId === null)
            throw new Error("The parameter 'subscriberId' must be defined.");
        url_ = url_.replace("{SubscriberId}", encodeURIComponent("" + subscriberId));
        if (emailTemplateID === null)
            throw new Error("The parameter 'emailTemplateID' cannot be null.");
        else if (emailTemplateID !== undefined)
            url_ += "emailTemplateID=" + encodeURIComponent("" + emailTemplateID) + "&";
        if (vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' cannot be null.");
        else if (vehicleIdent !== undefined)
            url_ += "vehicleIdent=" + encodeURIComponent("" + vehicleIdent) + "&";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscription(_response);
        });
    }
    processSubscription(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData201);
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch subscriptions belonging the specified subsciber
     * @param subscriberId The subscriber owning the subscriptions
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param includeInactive (optional) If true, also include inactive subscriptions
     * @param search (optional)
     * @return Success
     */
    subscriptionsGET(subscriberId, pageNumber, pageSize, sortOrderAsc, sortBy, includeInactive, search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscribers/{SubscriberId}/Subscriptions?";
        if (subscriberId === undefined || subscriberId === null)
            throw new Error("The parameter 'subscriberId' must be defined.");
        url_ = url_.replace("{SubscriberId}", encodeURIComponent("" + subscriberId));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptionsGET(_response);
        });
    }
    processSubscriptionsGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all subscriptions
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param includeInactive (optional) If true, also include inactive subscriptions
     * @param search (optional) A string used as a search query
     * @return Success
     */
    subscriptionsGET2(pageNumber, pageSize, sortOrderAsc, sortBy, includeInactive, search, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions?";
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (includeInactive === null)
            throw new Error("The parameter 'includeInactive' cannot be null.");
        else if (includeInactive !== undefined)
            url_ += "IncludeInactive=" + encodeURIComponent("" + includeInactive) + "&";
        if (search === null)
            throw new Error("The parameter 'search' cannot be null.");
        else if (search !== undefined)
            url_ += "search=" + encodeURIComponent("" + search) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptionsGET2(_response);
        });
    }
    processSubscriptionsGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Activate a subscription
     * @param active (optional)
     * @return Success
     */
    activate2(subscriptionId, active, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}/activate?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        if (active === null)
            throw new Error("The parameter 'active' cannot be null.");
        else if (active !== undefined)
            url_ += "active=" + encodeURIComponent("" + active) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processActivate2(_response);
        });
    }
    processActivate2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a single subscription
     * @param subscriptionId The id of the subscription
     * @return Success
     */
    subscriptionsGET3(subscriptionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptionsGET3(_response);
        });
    }
    processSubscriptionsGET3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a QR Code belonging the the subscription
     * @param subscriptionId The subscription
     * @return Success
     */
    qRCodeGET(subscriptionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}/QRCode";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processQRCodeGET(_response);
        });
    }
    processQRCodeGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfQrCodeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch history for a single subscription
     * @param subscriptionId The id of the subscription
     * @return Success
     */
    history(subscriptionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/history/{SubscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processHistory(_response);
        });
    }
    processHistory(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfHistory_1OfOfSubscriptionHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    cars(subscriptionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/history/cars/{SubscriptionId}";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCars(_response);
        });
    }
    processCars(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfHistory_1OfOfSubscriptionCarHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a signature belonging to a subscription
     * @return Success
     */
    signature(subscriptionId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}/signature";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSignature(_response);
        });
    }
    processSignature(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a car to the specified subscription
     * @param subscriptionId The id of the subscription owning the car
     * @param body (optional) The car to be added
     * @return Success
     */
    car(subscriptionId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}/Car";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCar(_response);
        });
    }
    processCar(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add an area to the specified subscription
     * @param subscriptionId The id of the subscription
     * @param areaID The id of the area being added to the subscription
     * @param costumerID (optional)
     * @return Success
     */
    areaPOST(subscriptionId, areaID, costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}/Area/{AreaID}?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        if (areaID === undefined || areaID === null)
            throw new Error("The parameter 'areaID' must be defined.");
        url_ = url_.replace("{AreaID}", encodeURIComponent("" + areaID));
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAreaPOST(_response);
        });
    }
    processAreaPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a subarea to the specified subscription
     * @param subscriptionId The id of the subscription
     * @param subAreaID The id of the area being added to the subscription
     * @param costumerID (optional)
     * @return Success
     */
    subAreaPOST(subscriptionId, subAreaID, costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionId}/SubArea/{SubAreaID}?";
        if (subscriptionId === undefined || subscriptionId === null)
            throw new Error("The parameter 'subscriptionId' must be defined.");
        url_ = url_.replace("{SubscriptionId}", encodeURIComponent("" + subscriptionId));
        if (subAreaID === undefined || subAreaID === null)
            throw new Error("The parameter 'subAreaID' must be defined.");
        url_ = url_.replace("{SubAreaID}", encodeURIComponent("" + subAreaID));
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "POST",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubAreaPOST(_response);
        });
    }
    processSubAreaPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Deletes a subscription
     * @return Success
     */
    subscriptionsDELETE(subscriptionID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{SubscriptionID}", encodeURIComponent("" + subscriptionID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptionsDELETE(_response);
        });
    }
    processSubscriptionsDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a subscription
     * @param subscriptionID The id of the subscription being updated
     * @param costumerID (optional)
     * @param body (optional) The updated subscription
     * @return Success
     */
    subscriptionsPUT(subscriptionID, costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionID}?";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{SubscriptionID}", encodeURIComponent("" + subscriptionID));
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubscriptionsPUT(_response);
        });
    }
    processSubscriptionsPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Remove a car from a subscription
     * @param subscriptionID The id of the subscription being updated
     * @param carID The car being removed from the subscription
     * @return Success
     */
    carsDELETE(subscriptionID, carID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionID}/Cars/{CarID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{SubscriptionID}", encodeURIComponent("" + subscriptionID));
        if (carID === undefined || carID === null)
            throw new Error("The parameter 'carID' must be defined.");
        url_ = url_.replace("{CarID}", encodeURIComponent("" + carID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCarsDELETE(_response);
        });
    }
    processCarsDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Remove an Area from a subscription
     * @param subscriptionID The id of the subscription being updated
     * @param areaID The area being removed from the subscription
     * @return Success
     */
    areaDELETE(subscriptionID, areaID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionID}/Area/{AreaID}";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{SubscriptionID}", encodeURIComponent("" + subscriptionID));
        if (areaID === undefined || areaID === null)
            throw new Error("The parameter 'areaID' must be defined.");
        url_ = url_.replace("{AreaID}", encodeURIComponent("" + areaID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAreaDELETE(_response);
        });
    }
    processAreaDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Remove a SubArea from a subscription
     * @param subscriptionID The id of the subscription being updated
     * @param subAreaID The id of the subare being removed
     * @param costumerID (optional)
     * @return Success
     */
    subAreaDELETE(subscriptionID, subAreaID, costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Subscriptions/{SubscriptionID}/SubArea/{SubAreaID}?";
        if (subscriptionID === undefined || subscriptionID === null)
            throw new Error("The parameter 'subscriptionID' must be defined.");
        url_ = url_.replace("{SubscriptionID}", encodeURIComponent("" + subscriptionID));
        if (subAreaID === undefined || subAreaID === null)
            throw new Error("The parameter 'subAreaID' must be defined.");
        url_ = url_.replace("{SubAreaID}", encodeURIComponent("" + subAreaID));
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processSubAreaDELETE(_response);
        });
    }
    processSubAreaDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a terms of servce template
     * @param costumerID The customer owning the terms of service template
     * @return Success
     */
    termsOfServiceGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/TermsOfService/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processTermsOfServiceGET(_response);
        });
    }
    processTermsOfServiceGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfTermsOfServiceResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a terms of service template
     * @param costumerID The customer owning the terms of service template
     * @param body (optional) The new terms of service template
     * @return Success
     */
    termsOfServicePUT(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/TermsOfService/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processTermsOfServicePUT(_response);
        });
    }
    processTermsOfServicePUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfTermsOfServiceResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a charge template
     * @param costumerID The customer owning the charge template
     * @param body (optional) The new charge template
     * @return Success
     */
    chargePOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Charge/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processChargePOST(_response);
        });
    }
    processChargePOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfChargeTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a charge template
     * @param costumerID The customer owning the charge template
     * @return Success
     */
    chargeGET(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Charge/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processChargeGET(_response);
        });
    }
    processChargeGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfChargeTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add an email template
     * @param costumerID Customer owning the email template
     * @param body (optional) The email template to be added
     * @return Success
     */
    emailPOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Email/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailPOST(_response);
        });
    }
    processEmailPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch email templates
     * @param costumerID Customer owning the email template
     * @param emailTemplateType (optional) If set, the endpoint only returns template of the specified emailTemplateType
     * @return Success
     */
    emailGET(costumerID, emailTemplateType, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Email/{costumerID}?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (emailTemplateType === null)
            throw new Error("The parameter 'emailTemplateType' cannot be null.");
        else if (emailTemplateType !== undefined)
            url_ += "emailTemplateType=" + encodeURIComponent("" + emailTemplateType) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailGET(_response);
        });
    }
    processEmailGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an email template
     * @return Success
     */
    emailDELETE(emailTemplateId, costumerId, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Costumer/{costumerId}/Email/{emailTemplateId}";
        if (emailTemplateId === undefined || emailTemplateId === null)
            throw new Error("The parameter 'emailTemplateId' must be defined.");
        url_ = url_.replace("{emailTemplateId}", encodeURIComponent("" + emailTemplateId));
        if (costumerId === undefined || costumerId === null)
            throw new Error("The parameter 'costumerId' must be defined.");
        url_ = url_.replace("{costumerId}", encodeURIComponent("" + costumerId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailDELETE(_response);
        });
    }
    processEmailDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch a single email template
     * @param costumerID The customer owning the email template
     * @param templateID The id of the email template
     * @return Success
     */
    emailGET2(costumerID, templateID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Email/{costumerID}/{templateID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (templateID === undefined || templateID === null)
            throw new Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailGET2(_response);
        });
    }
    processEmailGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update an email template
     * @param costumerID The customer owning the email template
     * @param templateID The id of the email template
     * @param body (optional) The updated email template
     * @return Success
     */
    emailPATCH(costumerID, templateID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Email/{costumerID}/{templateID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (templateID === undefined || templateID === null)
            throw new Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEmailPATCH(_response);
        });
    }
    processEmailPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a paragraph to a template
     * @param costumerID The customer owning the email template
     * @param templateID The id of the email template
     * @param body (optional) The paragraph to be added
     * @return Success
     */
    paragraphsPOST(costumerID, templateID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Paragraphs/{costumerID}/{templateID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (templateID === undefined || templateID === null)
            throw new Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParagraphsPOST(_response);
        });
    }
    processParagraphsPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParagraphResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a paragraph
     * @param costumerID The customer owning the email template
     * @param templateID The id of the email template
     * @param paragraphID The id of the paragraph updated
     * @param body (optional) The paragraph being updated
     * @return Success
     */
    paragraphsPATCH(costumerID, templateID, paragraphID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Paragraphs/{costumerID}/{templateID}/{paragraphID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (templateID === undefined || templateID === null)
            throw new Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        if (paragraphID === undefined || paragraphID === null)
            throw new Error("The parameter 'paragraphID' must be defined.");
        url_ = url_.replace("{paragraphID}", encodeURIComponent("" + paragraphID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PATCH",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParagraphsPATCH(_response);
        });
    }
    processParagraphsPATCH(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParagraphResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a pagraph
     * @param costumerID The customer owning the email template
     * @param templateID The id of the email template
     * @param paragraphID The id of the paragraph being deleted
     * @return Success
     */
    paragraphsDELETE(costumerID, templateID, paragraphID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Paragraphs/{costumerID}/{templateID}/{paragraphID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (templateID === undefined || templateID === null)
            throw new Error("The parameter 'templateID' must be defined.");
        url_ = url_.replace("{templateID}", encodeURIComponent("" + templateID));
        if (paragraphID === undefined || paragraphID === null)
            throw new Error("The parameter 'paragraphID' must be defined.");
        url_ = url_.replace("{paragraphID}", encodeURIComponent("" + paragraphID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParagraphsDELETE(_response);
        });
    }
    processParagraphsDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch Edit Events Texts
     * @param customerID Customer owning the eventtexts
     * @param languageCode (optional) If set, only return eventtexts with that specific languageCode
     * @param editEvent (optional) If set, only return editEvents with that specific editEvent
     * @return Success
     */
    eventTextsGET(customerID, languageCode, editEvent, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Customers/{customerID}/EventTexts?";
        if (customerID === undefined || customerID === null)
            throw new Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        if (languageCode === null)
            throw new Error("The parameter 'languageCode' cannot be null.");
        else if (languageCode !== undefined)
            url_ += "languageCode=" + encodeURIComponent("" + languageCode) + "&";
        if (editEvent === null)
            throw new Error("The parameter 'editEvent' cannot be null.");
        else if (editEvent !== undefined)
            url_ += "editEvent=" + encodeURIComponent("" + editEvent) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEventTextsGET(_response);
        });
    }
    processEventTextsGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfEventTextResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Overwrite an EventText
     * @param customerID Customer owning the eventtexts
     * @param body (optional) The eventtext to be added/updated
     * @return Success
     */
    eventTextsPUT(customerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Customers/{customerID}/EventTexts";
        if (customerID === undefined || customerID === null)
            throw new Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEventTextsPUT(_response);
        });
    }
    processEventTextsPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfEventTextResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an EventText
     * @param customerID Customer owning the eventtexts
     * @param eventTextID Event Text to be deleted
     * @return Success
     */
    eventTextsDELETE(customerID, eventTextID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Templates/Customers/{customerID}/EventTexts/{eventTextID}";
        if (customerID === undefined || customerID === null)
            throw new Error("The parameter 'customerID' must be defined.");
        url_ = url_.replace("{customerID}", encodeURIComponent("" + customerID));
        if (eventTextID === undefined || eventTextID === null)
            throw new Error("The parameter 'eventTextID' must be defined.");
        url_ = url_.replace("{eventTextID}", encodeURIComponent("" + eventTextID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEventTextsDELETE(_response);
        });
    }
    processEventTextsDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 204) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch all users
     * @param costumerID (optional)
     * @param subscriberID (optional) If set, the endpoint returns only users associated with that specific subscriber
     * @return Success
     */
    usersGET(costumerID, subscriberID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users?";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "CostumerID=" + encodeURIComponent("" + costumerID) + "&";
        if (subscriberID === null)
            throw new Error("The parameter 'subscriberID' cannot be null.");
        else if (subscriberID !== undefined)
            url_ += "subscriberID=" + encodeURIComponent("" + subscriberID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUsersGET(_response);
        });
    }
    processUsersGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a User
     * @param costumerID (optional) The customer owning the user, if not set uses the customer belonging the the current user
     * @param body (optional)
     * @return Success
     */
    usersPOST(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users?";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "CostumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUsersPOST(_response);
        });
    }
    processUsersPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 201) {
            const _responseText = response.data;
            let result201 = null;
            let resultData201 = _responseText;
            result201 = Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData201);
            return Promise.resolve(result201);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Find a user by ID
     * @param userID ID of the user
     * @return Success
     */
    usersGET2(userID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUsersGET2(_response);
        });
    }
    processUsersGET2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Find a mode configuration
     * @param userID The user owning the configuration
     * @return Success
     */
    configurationGET(userID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/mode/configuration/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processConfigurationGET(_response);
        });
    }
    processConfigurationGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfModeConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a mode configuration
     * @param userID The user owning the configuration
     * @param body (optional) The configuration to be added
     * @return Success
     */
    configurationPOST(userID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/mode/configuration/{userID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{userID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processConfigurationPOST(_response);
        });
    }
    processConfigurationPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfModeConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch the current user
     * @return Success
     */
    me(cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/me";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMe(_response);
        });
    }
    processMe(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param costumerID The customer to be impersonated as
     * @return Success
     */
    personate(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/personate/{costumerID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPersonate(_response);
        });
    }
    processPersonate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a User
     * @param userID Id of the user to be deleted
     * @return Success
     */
    usersDELETE(userID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/{UserID}";
        if (userID === undefined || userID === null)
            throw new Error("The parameter 'userID' must be defined.");
        url_ = url_.replace("{UserID}", encodeURIComponent("" + userID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUsersDELETE(_response);
        });
    }
    processUsersDELETE(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Update a User
     * @param userId Id of the user to be updated
     * @param body (optional) The updated user
     * @return Success
     */
    usersPUT(userId, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/Users/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUsersPUT(_response);
        });
    }
    processUsersPUT(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch tags from PRS
     * @param costumerID (optional) The costumerID is used to overwrite tag descriptions based on configurations
     * @return Success
     */
    prsTags(costumerID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/parking/prsTags?";
        if (costumerID === null)
            throw new Error("The parameter 'costumerID' cannot be null.");
        else if (costumerID !== undefined)
            url_ += "costumerID=" + encodeURIComponent("" + costumerID) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPrsTags(_response);
        });
    }
    processPrsTags(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfPrsTagResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch unterminated parkings from PRS
     * @param costumerID The customer owning the parkings
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param includeAccepted (optional) If false, the manuallyAccepted tag is included in the acceptanceTags list
     * @param body (optional)
     * @return Success
     */
    unterminated(costumerID, pageNumber, pageSize, sortOrderAsc, sortBy, includeAccepted, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/unterminated?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (includeAccepted === null)
            throw new Error("The parameter 'includeAccepted' cannot be null.");
        else if (includeAccepted !== undefined)
            url_ += "includeAccepted=" + encodeURIComponent("" + includeAccepted) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUnterminated(_response);
        });
    }
    processUnterminated(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch unpaid parkings from PRS
     * @param costumerID The customer owning the parkings
     * @param pageNumber (optional)
     * @param pageSize (optional)
     * @param sortOrderAsc (optional)
     * @param sortBy (optional)
     * @param departedBefore (optional)
     * @param body (optional)
     * @return Success
     */
    unpaidPOST(costumerID, pageNumber, pageSize, sortOrderAsc, sortBy, departedBefore, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/unpaid?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (pageNumber === null)
            throw new Error("The parameter 'pageNumber' cannot be null.");
        else if (pageNumber !== undefined)
            url_ += "PageNumber=" + encodeURIComponent("" + pageNumber) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (sortOrderAsc === null)
            throw new Error("The parameter 'sortOrderAsc' cannot be null.");
        else if (sortOrderAsc !== undefined)
            url_ += "SortOrderAsc=" + encodeURIComponent("" + sortOrderAsc) + "&";
        if (sortBy === null)
            throw new Error("The parameter 'sortBy' cannot be null.");
        else if (sortBy !== undefined)
            url_ += "SortBy=" + encodeURIComponent("" + sortBy) + "&";
        if (departedBefore === null)
            throw new Error("The parameter 'departedBefore' cannot be null.");
        else if (departedBefore !== undefined)
            url_ += "departedBefore=" + encodeURIComponent("" + departedBefore) + "&";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUnpaidPOST(_response);
        });
    }
    processUnpaidPOST(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = PagedResponse_1OfOfList_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @return Success
     */
    unpaidGET(costumerID, parkingRightID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/unpaid/{parkingRightID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processUnpaidGET(_response);
        });
    }
    processUnpaidGET(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = UnpaidParkingResponse.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Mark an unpaid parking as paid
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright being marked as paid
     * @return Success
     */
    markAsPaid(costumerID, parkingRightID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingRightID}/markAsPaid";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processMarkAsPaid(_response);
        });
    }
    processMarkAsPaid(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Mark a ParkingRight as departed
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright being marked as departed
     * @param departed The time of depature
     * @return Success
     */
    checkout(costumerID, parkingRightID, departed, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingRightID}/checkout/{departed}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        if (departed === undefined || departed === null)
            throw new Error("The parameter 'departed' must be defined.");
        url_ = url_.replace("{departed}", encodeURIComponent("" + departed));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCheckout(_response);
        });
    }
    processCheckout(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a vehicleIdent to a ParkingRight
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright receiving the vehicleIdent
     * @param vehicleIdent The vehicleIdent to be added
     * @param countryCode (optional) The country code of the vehicleIdent
     * @return Success
     */
    edit(costumerID, parkingRightID, vehicleIdent, countryCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingRightID}/edit/{vehicleIdent}?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEdit(_response);
        });
    }
    processEdit(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Add a vehicleIdent to a Orphan
     * @param costumerID The customer owning the parkingright
     * @param orphanID The id of the orphan receiving the vehicleIdent
     * @param vehicleIdent The vehicleIdent to be added
     * @param countryCode (optional) The country code of the vehicleIdent
     * @return Success
     */
    edit2(costumerID, orphanID, vehicleIdent, countryCode, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/orphan/{orphanID}/edit/{vehicleIdent}?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (orphanID === undefined || orphanID === null)
            throw new Error("The parameter 'orphanID' must be defined.");
        url_ = url_.replace("{orphanID}", encodeURIComponent("" + orphanID));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        if (countryCode === null)
            throw new Error("The parameter 'countryCode' cannot be null.");
        else if (countryCode !== undefined)
            url_ += "countryCode=" + encodeURIComponent("" + countryCode) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processEdit2(_response);
        });
    }
    processEdit2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete an orphan
     * @param costumerID The customer owning the orphan
     * @param orphanID The id of the orphan being deleted
     * @return Success
     */
    orphan(costumerID, orphanID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/orphan/{orphanID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (orphanID === undefined || orphanID === null)
            throw new Error("The parameter 'orphanID' must be defined.");
        url_ = url_.replace("{orphanID}", encodeURIComponent("" + orphanID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processOrphan(_response);
        });
    }
    processOrphan(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Accept a parkingRight
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright being accepted
     * @return Success
     */
    accept(costumerID, parkingRightID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingRightID}/accept";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processAccept(_response);
        });
    }
    processAccept(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Delete a parkingright
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright being deleted
     * @return Success
     */
    parking(costumerID, parkingRightID, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingRightID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "DELETE",
            url: url_,
            headers: {},
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParking(_response);
        });
    }
    processParking(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve(null);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch images belonging to a parking
     * @param costumerID The customer owning the parking
     * @param parkingID The id of the parking having the images
     * @param isOrphan (optional) True if the entity type of the parking is orphan
     * @return Success
     */
    images(costumerID, parkingID, isOrphan, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingID}/images?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingID === undefined || parkingID === null)
            throw new Error("The parameter 'parkingID' must be defined.");
        url_ = url_.replace("{parkingID}", encodeURIComponent("" + parkingID));
        if (isOrphan === null)
            throw new Error("The parameter 'isOrphan' cannot be null.");
        else if (isOrphan !== undefined)
            url_ += "isOrphan=" + encodeURIComponent("" + isOrphan) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processImages(_response);
        });
    }
    processImages(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfList_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Fetch an image
     * @param costumerID The customer owning the parking
     * @param parkingID The id of the parking having the image
     * @param imageName The name of the image
     * @return Success
     */
    images2(costumerID, parkingID, imageName, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/parking/{parkingID}/images/{imageName}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingID === undefined || parkingID === null)
            throw new Error("The parameter 'parkingID' must be defined.");
        url_ = url_.replace("{parkingID}", encodeURIComponent("" + parkingID));
        if (imageName === undefined || imageName === null)
            throw new Error("The parameter 'imageName' must be defined.");
        url_ = url_.replace("{imageName}", encodeURIComponent("" + imageName));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processImages2(_response);
        });
    }
    processImages2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Merge a parkingright with an orphan
     * @param costumerID The customer owning the parkingright and orphan
     * @param parkingRightID The parkingright being merged
     * @param orphanID The orphan being merged
     * @return Success
     */
    orhpans(costumerID, parkingRightID, orphanID, cancelToken) {
        let url_ = this.baseUrl +
            "/api/v1/costumer/{costumerID}/merge/parkingrights/{parkingRightID}/orhpans/{orphanID}";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        if (orphanID === undefined || orphanID === null)
            throw new Error("The parameter 'orphanID' must be defined.");
        url_ = url_.replace("{orphanID}", encodeURIComponent("" + orphanID));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "PATCH",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processOrhpans(_response);
        });
    }
    processOrhpans(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = Response_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(resultData200);
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Generate a PDF charge document for a ParkingRight
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright having the image
     * @param vehicleIdent The vehicle identifier appearing on the Charge Document
     * @param chargeAmount (optional) The charge amount appearing on the Charge Document
     * @param images (optional) A list of imagenames, used to fetch images appearing on the Charge Document
     * @param nameOverwrite (optional) Overwrite the person name appearing on the Charge Document
     * @param addressOverwrite (optional) Overwrite the address appearing on the Charge Document
     * @param cityOverwrite (optional) Overwrite the city appearing on the Charge Document
     * @param feeOverwrite (optional)
     * @return Success
     */
    charge(costumerID, parkingRightID, vehicleIdent, chargeAmount, images, nameOverwrite, addressOverwrite, cityOverwrite, feeOverwrite, cancelToken) {
        let url_ = this.baseUrl +
            "/api/v1/costumer/{costumerID}/parking/{parkingRightID}/charge/{vehicleIdent}?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        if (chargeAmount === null)
            throw new Error("The parameter 'chargeAmount' cannot be null.");
        else if (chargeAmount !== undefined)
            url_ += "chargeAmount=" + encodeURIComponent("" + chargeAmount) + "&";
        if (images === null)
            throw new Error("The parameter 'images' cannot be null.");
        else if (images !== undefined)
            images &&
                images.forEach(item => {
                    url_ += "images=" + encodeURIComponent("" + item) + "&";
                });
        if (nameOverwrite === null)
            throw new Error("The parameter 'nameOverwrite' cannot be null.");
        else if (nameOverwrite !== undefined)
            url_ += "nameOverwrite=" + encodeURIComponent("" + nameOverwrite) + "&";
        if (addressOverwrite === null)
            throw new Error("The parameter 'addressOverwrite' cannot be null.");
        else if (addressOverwrite !== undefined)
            url_ += "addressOverwrite=" + encodeURIComponent("" + addressOverwrite) + "&";
        if (cityOverwrite === null)
            throw new Error("The parameter 'cityOverwrite' cannot be null.");
        else if (cityOverwrite !== undefined)
            url_ += "cityOverwrite=" + encodeURIComponent("" + cityOverwrite) + "&";
        if (feeOverwrite === null)
            throw new Error("The parameter 'feeOverwrite' cannot be null.");
        else if (feeOverwrite !== undefined)
            url_ += "feeOverwrite=" + encodeURIComponent("" + feeOverwrite) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processCharge(_response);
        });
    }
    processCharge(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers
                ? response.headers["content-disposition"]
                : undefined;
            let fileNameMatch = contentDisposition
                ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
                : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1
                ? fileNameMatch[3] || fileNameMatch[2]
                : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition
                    ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
                    : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({
                fileName: fileName,
                status: status,
                data: new Blob([response.data], { type: response.headers["content-type"] }),
                headers: _headers,
            });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Generate a HTML charge document for a ParkingRight
     * @param costumerID The customer owning the parkingright
     * @param parkingRightID The id of the parkingright having the image
     * @param vehicleIdent The vehicle identifier appearing on the Charge Document
     * @param chargeAmount (optional) The charge amount appearing on the Charge Document
     * @param images (optional) A list of imagenames, used to fetch images appearing on the Charge Document
     * @param nameOverwrite (optional) Overwrite the person name appearing on the Charge Document
     * @param addressOverwrite (optional) Overwrite the address appearing on the Charge Document
     * @param cityOverwrite (optional) Overwrite the city appearing on the Charge Document
     * @param feeOverwrite (optional)
     * @return Success
     */
    preview(costumerID, parkingRightID, vehicleIdent, chargeAmount, images, nameOverwrite, addressOverwrite, cityOverwrite, feeOverwrite, cancelToken) {
        let url_ = this.baseUrl +
            "/api/v1/costumer/{costumerID}/parking/{parkingRightID}/charge/{vehicleIdent}/preview?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (parkingRightID === undefined || parkingRightID === null)
            throw new Error("The parameter 'parkingRightID' must be defined.");
        url_ = url_.replace("{parkingRightID}", encodeURIComponent("" + parkingRightID));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        if (chargeAmount === null)
            throw new Error("The parameter 'chargeAmount' cannot be null.");
        else if (chargeAmount !== undefined)
            url_ += "chargeAmount=" + encodeURIComponent("" + chargeAmount) + "&";
        if (images === null)
            throw new Error("The parameter 'images' cannot be null.");
        else if (images !== undefined)
            images &&
                images.forEach(item => {
                    url_ += "images=" + encodeURIComponent("" + item) + "&";
                });
        if (nameOverwrite === null)
            throw new Error("The parameter 'nameOverwrite' cannot be null.");
        else if (nameOverwrite !== undefined)
            url_ += "nameOverwrite=" + encodeURIComponent("" + nameOverwrite) + "&";
        if (addressOverwrite === null)
            throw new Error("The parameter 'addressOverwrite' cannot be null.");
        else if (addressOverwrite !== undefined)
            url_ += "addressOverwrite=" + encodeURIComponent("" + addressOverwrite) + "&";
        if (cityOverwrite === null)
            throw new Error("The parameter 'cityOverwrite' cannot be null.");
        else if (cityOverwrite !== undefined)
            url_ += "cityOverwrite=" + encodeURIComponent("" + cityOverwrite) + "&";
        if (feeOverwrite === null)
            throw new Error("The parameter 'feeOverwrite' cannot be null.");
        else if (feeOverwrite !== undefined)
            url_ += "feeOverwrite=" + encodeURIComponent("" + feeOverwrite) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPreview(_response);
        });
    }
    processPreview(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            result200 = resultData200 !== undefined ? resultData200 : null;
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Find mergeable parkingrights
     * @param costumerID The customer owning the parkingrights
     * @param areaId The area in which to search
     * @param vehicleIdent The vehicle ident to search for
     * @param startedBefore (optional) If set, filter parkingrights started before the datetime
     * @return Success
     */
    parkingrights(costumerID, areaId, vehicleIdent, startedBefore, cancelToken) {
        let url_ = this.baseUrl +
            "/api/v1/costumer/{costumerID}/area/{areaId}/vehicle/{vehicleIdent}/parkingrights?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        if (startedBefore === null)
            throw new Error("The parameter 'startedBefore' cannot be null.");
        else if (startedBefore !== undefined)
            url_ += "startedBefore=" + encodeURIComponent("" + startedBefore) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processParkingrights(_response);
        });
    }
    processParkingrights(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(ParkingRight.fromJS(item));
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * Find mergeable orphans
     * @param costumerID The customer owning the parkingrights
     * @param areaId The area in which to search
     * @param vehicleIdent The vehicle ident to search for
     * @param endedAfter (optional) If set, filter orphans ended before the datetime
     * @return Success
     */
    orphans(costumerID, areaId, vehicleIdent, endedAfter, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/area/{areaId}/vehicle/{vehicleIdent}/orphans?";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        if (areaId === undefined || areaId === null)
            throw new Error("The parameter 'areaId' must be defined.");
        url_ = url_.replace("{areaId}", encodeURIComponent("" + areaId));
        if (vehicleIdent === undefined || vehicleIdent === null)
            throw new Error("The parameter 'vehicleIdent' must be defined.");
        url_ = url_.replace("{vehicleIdent}", encodeURIComponent("" + vehicleIdent));
        if (endedAfter === null)
            throw new Error("The parameter 'endedAfter' cannot be null.");
        else if (endedAfter !== undefined)
            url_ += "endedAfter=" + encodeURIComponent("" + endedAfter) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            url: url_,
            headers: {
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processOrphans(_response);
        });
    }
    processOrphans(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200 = null;
            let resultData200 = _responseText;
            if (Array.isArray(resultData200)) {
                result200 = [];
                for (let item of resultData200)
                    result200.push(Orphan.fromJS(item));
            }
            else {
                result200 = null;
            }
            return Promise.resolve(result200);
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
    /**
     * @param body (optional)
     * @return Success
     */
    previewChargeTemplate(costumerID, body, cancelToken) {
        let url_ = this.baseUrl + "/api/v1/costumer/{costumerID}/preview-charge-template";
        if (costumerID === undefined || costumerID === null)
            throw new Error("The parameter 'costumerID' must be defined.");
        url_ = url_.replace("{costumerID}", encodeURIComponent("" + costumerID));
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            data: content_,
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                Accept: "text/plain",
            },
            cancelToken,
        };
        return this.instance
            .request(options_)
            .catch((_error) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            }
            else {
                throw _error;
            }
        })
            .then((_response) => {
            return this.processPreviewChargeTemplate(_response);
        });
    }
    processPreviewChargeTemplate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers
                ? response.headers["content-disposition"]
                : undefined;
            let fileNameMatch = contentDisposition
                ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition)
                : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1
                ? fileNameMatch[3] || fileNameMatch[2]
                : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            }
            else {
                fileNameMatch = contentDisposition
                    ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition)
                    : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return Promise.resolve({
                fileName: fileName,
                status: status,
                data: new Blob([response.data], { type: response.headers["content-type"] }),
                headers: _headers,
            });
        }
        else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve(null);
    }
}
export class BadRequestResult {
    statusCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.statusCode = _data["statusCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new BadRequestResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["statusCode"] = this.statusCode;
        return data;
    }
}
export class NoContentResult {
    statusCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.statusCode = _data["statusCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new NoContentResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["statusCode"] = this.statusCode;
        return data;
    }
}
export class NotFoundResult {
    statusCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.statusCode = _data["statusCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new NotFoundResult();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["statusCode"] = this.statusCode;
        return data;
    }
}
export var EditEvent;
(function (EditEvent) {
    EditEvent["AddCar"] = "AddCar";
    EditEvent["RemoveCar"] = "RemoveCar";
    EditEvent["AddArea"] = "AddArea";
    EditEvent["RemoveArea"] = "RemoveArea";
    EditEvent["ChangeName"] = "ChangeName";
    EditEvent["ChangeEmail"] = "ChangeEmail";
    EditEvent["ActivateSubscription"] = "ActivateSubscription";
    EditEvent["DeactivateSubscription"] = "DeactivateSubscription";
    EditEvent["ChangeEndDate"] = "ChangeEndDate";
})(EditEvent || (EditEvent = {}));
export var LanguageCode;
(function (LanguageCode) {
    LanguageCode["Da"] = "da";
    LanguageCode["En"] = "en";
})(LanguageCode || (LanguageCode = {}));
export class AreaRequest {
    id;
    name;
    showInParkAdmin;
    subAreas;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInParkAdmin = _data["showInParkAdmin"];
            if (Array.isArray(_data["subAreas"])) {
                this.subAreas = [];
                for (let item of _data["subAreas"])
                    this.subAreas.push(SubAreaRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new AreaRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInParkAdmin"] = this.showInParkAdmin;
        if (Array.isArray(this.subAreas)) {
            data["subAreas"] = [];
            for (let item of this.subAreas)
                data["subAreas"].push(item.toJSON());
        }
        return data;
    }
}
export class AuthenticateRequest {
    username;
    password;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.username = _data["username"];
            this.password = _data["password"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new AuthenticateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["username"] = this.username;
        data["password"] = this.password;
        return data;
    }
}
export class CarRequest {
    name;
    licensePlate;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.licensePlate = _data["licensePlate"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new CarRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}
export class CarUpdateRequest {
    name;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new CarUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class ChargeTemplateRequest {
    template;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.template = _data["template"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ChargeTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["template"] = this.template;
        return data;
    }
}
export class CostumerRequest {
    costumerName;
    emailConfig;
    prsAreaManager;
    prsCompanyID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.costumerName = _data["costumerName"];
            this.emailConfig = _data["emailConfig"];
            this.prsAreaManager = _data["prsAreaManager"];
            this.prsCompanyID = _data["prsCompanyID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new CostumerRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["costumerName"] = this.costumerName;
        data["emailConfig"] = this.emailConfig;
        data["prsAreaManager"] = this.prsAreaManager;
        data["prsCompanyID"] = this.prsCompanyID;
        return data;
    }
}
export class CostumerUpdateRequest {
    emailConfig;
    prsAreaManager;
    prsCompanyID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailConfig = _data["emailConfig"];
            this.prsAreaManager = _data["prsAreaManager"];
            this.prsCompanyID = _data["prsCompanyID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new CostumerUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["emailConfig"] = this.emailConfig;
        data["prsAreaManager"] = this.prsAreaManager;
        data["prsCompanyID"] = this.prsCompanyID;
        return data;
    }
}
export class EmailConfigurationRequest {
    emailTemplateTypeID;
    emailSendingStateID;
    defaultEmailTemplateID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailTemplateTypeID = _data["emailTemplateTypeID"];
            this.emailSendingStateID = _data["emailSendingStateID"];
            this.defaultEmailTemplateID = _data["defaultEmailTemplateID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailConfigurationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["emailTemplateTypeID"] = this.emailTemplateTypeID;
        data["emailSendingStateID"] = this.emailSendingStateID;
        data["defaultEmailTemplateID"] = this.defaultEmailTemplateID;
        return data;
    }
}
export class EmailTemplateRequest {
    emailTemplateName;
    emailTemplateTypeID;
    subject;
    signatureLogo;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailTemplateName = _data["emailTemplateName"];
            this.emailTemplateTypeID = _data["emailTemplateTypeID"];
            this.subject = _data["subject"];
            this.signatureLogo = _data["signatureLogo"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["emailTemplateName"] = this.emailTemplateName;
        data["emailTemplateTypeID"] = this.emailTemplateTypeID;
        data["subject"] = this.subject;
        data["signatureLogo"] = this.signatureLogo;
        return data;
    }
}
export class EmailTemplateUpdateRequest {
    emailTemplateName;
    emailTemplateTypeID;
    subject;
    config;
    signatureLogo;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailTemplateName = _data["emailTemplateName"];
            this.emailTemplateTypeID = _data["emailTemplateTypeID"];
            this.subject = _data["subject"];
            this.config = _data["config"];
            this.signatureLogo = _data["signatureLogo"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailTemplateUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["emailTemplateName"] = this.emailTemplateName;
        data["emailTemplateTypeID"] = this.emailTemplateTypeID;
        data["subject"] = this.subject;
        data["config"] = this.config;
        data["signatureLogo"] = this.signatureLogo;
        return data;
    }
}
export class EventTextRequest {
    editEventID;
    languageCodeID;
    text;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.editEventID = _data["editEventID"];
            this.languageCodeID = _data["languageCodeID"];
            this.text = _data["text"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EventTextRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["editEventID"] = this.editEventID;
        data["languageCodeID"] = this.languageCodeID;
        data["text"] = this.text;
        return data;
    }
}
export class FeatureRequest {
    featureID;
    feature;
    description;
    active;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.featureID = _data["featureID"];
            this.feature = _data["feature"];
            this.description = _data["description"];
            this.active = _data["active"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new FeatureRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["featureID"] = this.featureID;
        data["feature"] = this.feature;
        data["description"] = this.description;
        data["active"] = this.active;
        return data;
    }
}
export class FeatureToggleRequest {
    active;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.active = _data["active"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new FeatureToggleRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["active"] = this.active;
        return data;
    }
}
export class ModeConfigurationRequest {
    subscriptonTypeID;
    welcomeEmailEmplateID;
    headerLogo;
    footerLogo;
    areas;
    features;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.areas = [];
            this.features = [];
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptonTypeID = _data["subscriptonTypeID"];
            this.welcomeEmailEmplateID = _data["welcomeEmailEmplateID"];
            this.headerLogo = _data["headerLogo"];
            this.footerLogo = _data["footerLogo"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaRequest.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [];
                for (let item of _data["features"])
                    this.features.push(FeatureRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ModeConfigurationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["subscriptonTypeID"] = this.subscriptonTypeID;
        data["welcomeEmailEmplateID"] = this.welcomeEmailEmplateID;
        data["headerLogo"] = this.headerLogo;
        data["footerLogo"] = this.footerLogo;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}
export class ParagraphRequest {
    title;
    body;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParagraphRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        return data;
    }
}
export class ParagraphUpdateRequest {
    title;
    body;
    order;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.title = _data["title"];
            this.body = _data["body"];
            this.order = _data["order"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParagraphUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["title"] = this.title;
        data["body"] = this.body;
        data["order"] = this.order;
        return data;
    }
}
export class ParkingQueryRequest {
    areas;
    inclusionTags;
    exclusionTags;
    acceptanceTags;
    from;
    to;
    vehicleIdent;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaRequest.fromJS(item));
            }
            if (Array.isArray(_data["inclusionTags"])) {
                this.inclusionTags = [];
                for (let item of _data["inclusionTags"])
                    this.inclusionTags.push(PrsTagRequest.fromJS(item));
            }
            if (Array.isArray(_data["exclusionTags"])) {
                this.exclusionTags = [];
                for (let item of _data["exclusionTags"])
                    this.exclusionTags.push(PrsTagRequest.fromJS(item));
            }
            if (Array.isArray(_data["acceptanceTags"])) {
                this.acceptanceTags = [];
                for (let item of _data["acceptanceTags"])
                    this.acceptanceTags.push(PrsTagRequest.fromJS(item));
            }
            this.from = _data["from"];
            this.to = _data["to"];
            this.vehicleIdent = _data["vehicleIdent"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingQueryRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.inclusionTags)) {
            data["inclusionTags"] = [];
            for (let item of this.inclusionTags)
                data["inclusionTags"].push(item.toJSON());
        }
        if (Array.isArray(this.exclusionTags)) {
            data["exclusionTags"] = [];
            for (let item of this.exclusionTags)
                data["exclusionTags"].push(item.toJSON());
        }
        if (Array.isArray(this.acceptanceTags)) {
            data["acceptanceTags"] = [];
            for (let item of this.acceptanceTags)
                data["acceptanceTags"].push(item.toJSON());
        }
        data["from"] = this.from;
        data["to"] = this.to;
        data["vehicleIdent"] = this.vehicleIdent;
        return data;
    }
}
export class ParkingTaggerRequest {
    lookupAndValidateDNK;
    lookupAndValidateNOR;
    duration1Enabled;
    duration1Value;
    duration2Enabled;
    duration2Value;
    duration3Enabled;
    duration3Value;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.lookupAndValidateDNK = _data["lookupAndValidateDNK"];
            this.lookupAndValidateNOR = _data["lookupAndValidateNOR"];
            this.duration1Enabled = _data["duration1Enabled"];
            this.duration1Value = _data["duration1Value"];
            this.duration2Enabled = _data["duration2Enabled"];
            this.duration2Value = _data["duration2Value"];
            this.duration3Enabled = _data["duration3Enabled"];
            this.duration3Value = _data["duration3Value"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingTaggerRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["lookupAndValidateDNK"] = this.lookupAndValidateDNK;
        data["lookupAndValidateNOR"] = this.lookupAndValidateNOR;
        data["duration1Enabled"] = this.duration1Enabled;
        data["duration1Value"] = this.duration1Value;
        data["duration2Enabled"] = this.duration2Enabled;
        data["duration2Value"] = this.duration2Value;
        data["duration3Enabled"] = this.duration3Enabled;
        data["duration3Value"] = this.duration3Value;
        return data;
    }
}
export class PreviewTemplateRequest {
    template;
    logo;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.template = _data["template"];
            this.logo = _data["logo"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PreviewTemplateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["template"] = this.template;
        data["logo"] = this.logo;
        return data;
    }
}
export class PrsTagRequest {
    name;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PrsTagRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class RefreshTokenRequest {
    refreshToken;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new RefreshTokenRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}
export class RevokeTokenRequest {
    refreshToken;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.refreshToken = _data["refreshToken"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new RevokeTokenRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["refreshToken"] = this.refreshToken;
        return data;
    }
}
export class SensitiveDataConfigurationRequest {
    maskableEntity;
    maskingAction;
    lifeTime;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.maskableEntity = _data["maskableEntity"];
            this.maskingAction = _data["maskingAction"];
            this.lifeTime = _data["lifeTime"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SensitiveDataConfigurationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["maskableEntity"] = this.maskableEntity;
        data["maskingAction"] = this.maskingAction;
        data["lifeTime"] = this.lifeTime;
        return data;
    }
}
export class StatisticsGraphConfiguration {
    minutesPerInterval;
    numberOfIntervals;
    skipIntervals;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.minutesPerInterval = _data["minutesPerInterval"];
            this.numberOfIntervals = _data["numberOfIntervals"];
            this.skipIntervals = _data["skipIntervals"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsGraphConfiguration();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["minutesPerInterval"] = this.minutesPerInterval;
        data["numberOfIntervals"] = this.numberOfIntervals;
        data["skipIntervals"] = this.skipIntervals;
        return data;
    }
}
export class StatisticsRequest {
    from;
    to;
    areas;
    parkingRightType;
    parkingRightSource;
    durationGraphConfiguration;
    timeZone;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.areas = [];
            this.parkingRightType = [];
            this.parkingRightSource = [];
            this.durationGraphConfiguration = new StatisticsGraphConfiguration();
        }
    }
    init(_data) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaRequest.fromJS(item));
            }
            if (Array.isArray(_data["parkingRightType"])) {
                this.parkingRightType = [];
                for (let item of _data["parkingRightType"])
                    this.parkingRightType.push(item);
            }
            if (Array.isArray(_data["parkingRightSource"])) {
                this.parkingRightSource = [];
                for (let item of _data["parkingRightSource"])
                    this.parkingRightSource.push(item);
            }
            this.durationGraphConfiguration = _data["durationGraphConfiguration"]
                ? StatisticsGraphConfiguration.fromJS(_data["durationGraphConfiguration"])
                : new StatisticsGraphConfiguration();
            this.timeZone = _data["timeZone"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.parkingRightType)) {
            data["parkingRightType"] = [];
            for (let item of this.parkingRightType)
                data["parkingRightType"].push(item);
        }
        if (Array.isArray(this.parkingRightSource)) {
            data["parkingRightSource"] = [];
            for (let item of this.parkingRightSource)
                data["parkingRightSource"].push(item);
        }
        data["durationGraphConfiguration"] = this.durationGraphConfiguration
            ? this.durationGraphConfiguration.toJSON()
            : undefined;
        data["timeZone"] = this.timeZone;
        return data;
    }
}
export class SubAreaRequest {
    id;
    name;
    showInParkAdmin;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.showInParkAdmin = _data["showInParkAdmin"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubAreaRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["showInParkAdmin"] = this.showInParkAdmin;
        return data;
    }
}
export class SubscriberCompanyRequest {
    name;
    email;
    remark;
    address1;
    address2;
    district;
    city;
    zipcode;
    country;
    cvr;
    attPersonName;
    phoneNumber;
    recieveNewsLetter;
    externalCostumerID;
    defaultWelcomeEmailID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.remark = _data["remark"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.zipcode = _data["zipcode"];
            this.country = _data["country"];
            this.cvr = _data["cvr"];
            this.attPersonName = _data["attPersonName"];
            this.phoneNumber = _data["phoneNumber"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.externalCostumerID = _data["externalCostumerID"];
            this.defaultWelcomeEmailID = _data["defaultWelcomeEmailID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriberCompanyRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["remark"] = this.remark;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["district"] = this.district;
        data["city"] = this.city;
        data["zipcode"] = this.zipcode;
        data["country"] = this.country;
        data["cvr"] = this.cvr;
        data["attPersonName"] = this.attPersonName;
        data["phoneNumber"] = this.phoneNumber;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["externalCostumerID"] = this.externalCostumerID;
        data["defaultWelcomeEmailID"] = this.defaultWelcomeEmailID;
        return data;
    }
}
export class SubscriberPersonRequest {
    firstName;
    lastName;
    email;
    remark;
    address1;
    address2;
    district;
    city;
    zipcode;
    country;
    phoneNumber;
    recieveNewsLetter;
    externalCostumerID;
    defaultWelcomeEmailID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.email = _data["email"];
            this.remark = _data["remark"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.zipcode = _data["zipcode"];
            this.country = _data["country"];
            this.phoneNumber = _data["phoneNumber"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.externalCostumerID = _data["externalCostumerID"];
            this.defaultWelcomeEmailID = _data["defaultWelcomeEmailID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriberPersonRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["email"] = this.email;
        data["remark"] = this.remark;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["district"] = this.district;
        data["city"] = this.city;
        data["zipcode"] = this.zipcode;
        data["country"] = this.country;
        data["phoneNumber"] = this.phoneNumber;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["externalCostumerID"] = this.externalCostumerID;
        data["defaultWelcomeEmailID"] = this.defaultWelcomeEmailID;
        return data;
    }
}
export class SubscriberUpdateRequest {
    firstName;
    lastName;
    name;
    email;
    remark;
    address1;
    address2;
    district;
    city;
    zipcode;
    country;
    cvr;
    attPersonName;
    phoneNumber;
    externalCostumerID;
    recieveNewsLetter;
    defaultWelcomeEmailID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.remark = _data["remark"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.zipcode = _data["zipcode"];
            this.country = _data["country"];
            this.cvr = _data["cvr"];
            this.attPersonName = _data["attPersonName"];
            this.phoneNumber = _data["phoneNumber"];
            this.externalCostumerID = _data["externalCostumerID"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.defaultWelcomeEmailID = _data["defaultWelcomeEmailID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriberUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["name"] = this.name;
        data["email"] = this.email;
        data["remark"] = this.remark;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["district"] = this.district;
        data["city"] = this.city;
        data["zipcode"] = this.zipcode;
        data["country"] = this.country;
        data["cvr"] = this.cvr;
        data["attPersonName"] = this.attPersonName;
        data["phoneNumber"] = this.phoneNumber;
        data["externalCostumerID"] = this.externalCostumerID;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["defaultWelcomeEmailID"] = this.defaultWelcomeEmailID;
        return data;
    }
}
export class SubscriptionRequest {
    name;
    email;
    primaryAreaID;
    fromDate;
    toDate;
    subscriptionType;
    areas;
    cars;
    phoneNumber;
    recieveNewsLetter;
    remark;
    signature;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.subscriptionType = new SubscriptionTypeRequest();
            this.areas = [];
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.primaryAreaID = _data["primaryAreaID"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.subscriptionType = _data["subscriptionType"]
                ? SubscriptionTypeRequest.fromJS(_data["subscriptionType"])
                : new SubscriptionTypeRequest();
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaRequest.fromJS(item));
            }
            if (Array.isArray(_data["cars"])) {
                this.cars = [];
                for (let item of _data["cars"])
                    this.cars.push(CarRequest.fromJS(item));
            }
            this.phoneNumber = _data["phoneNumber"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.remark = _data["remark"];
            this.signature = _data["signature"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["primaryAreaID"] = this.primaryAreaID;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["subscriptionType"] = this.subscriptionType
            ? this.subscriptionType.toJSON()
            : undefined;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item.toJSON());
        }
        data["phoneNumber"] = this.phoneNumber;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["remark"] = this.remark;
        data["signature"] = this.signature;
        return data;
    }
}
export class SubscriptionTypeRequest {
    subscriptionTypeId;
    subscriptionType;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionTypeId = _data["subscriptionTypeId"];
            this.subscriptionType = _data["subscriptionType"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionTypeRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["subscriptionTypeId"] = this.subscriptionTypeId;
        data["subscriptionType"] = this.subscriptionType;
        return data;
    }
}
export class SubscriptionUpdateRequest {
    name;
    email;
    toDate;
    subscriptionType;
    phoneNumber;
    recieveNewsLetter;
    remark;
    active;
    areas;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.subscriptionType = new SubscriptionTypeRequest();
            this.areas = [];
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.toDate = _data["toDate"];
            this.subscriptionType = _data["subscriptionType"]
                ? SubscriptionTypeRequest.fromJS(_data["subscriptionType"])
                : new SubscriptionTypeRequest();
            this.phoneNumber = _data["phoneNumber"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.remark = _data["remark"];
            this.active = _data["active"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["toDate"] = this.toDate;
        data["subscriptionType"] = this.subscriptionType
            ? this.subscriptionType.toJSON()
            : undefined;
        data["phoneNumber"] = this.phoneNumber;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["remark"] = this.remark;
        data["active"] = this.active;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }
}
export class TermsOfServiceRequest {
    mainTitle;
    headerLogo;
    footerLogo;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.mainTitle = _data["mainTitle"];
            this.headerLogo = _data["headerLogo"];
            this.footerLogo = _data["footerLogo"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new TermsOfServiceRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["mainTitle"] = this.mainTitle;
        data["headerLogo"] = this.headerLogo;
        data["footerLogo"] = this.footerLogo;
        return data;
    }
}
export class UpdateAreaRequest {
    defaultChargeAmount;
    showInParkAdmin;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.defaultChargeAmount = _data["defaultChargeAmount"];
            this.showInParkAdmin = _data["showInParkAdmin"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new UpdateAreaRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["defaultChargeAmount"] = this.defaultChargeAmount;
        data["showInParkAdmin"] = this.showInParkAdmin;
        return data;
    }
}
export class UserRequest {
    name;
    username;
    password;
    accessLevel;
    userTypeID;
    modeID;
    subscriberID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.username = _data["username"];
            this.password = _data["password"];
            this.accessLevel = _data["accessLevel"];
            this.userTypeID = _data["userTypeID"];
            this.modeID = _data["modeID"];
            this.subscriberID = _data["subscriberID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new UserRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        data["username"] = this.username;
        data["password"] = this.password;
        data["accessLevel"] = this.accessLevel;
        data["userTypeID"] = this.userTypeID;
        data["modeID"] = this.modeID;
        data["subscriberID"] = this.subscriberID;
        return data;
    }
}
export class UserUpdateRequest {
    name;
    language;
    password;
    userTypeID;
    accessLevel;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            this.language = _data["language"];
            this.password = _data["password"];
            this.userTypeID = _data["userTypeID"];
            this.accessLevel = _data["accessLevel"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new UserUpdateRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        data["language"] = this.language;
        data["password"] = this.password;
        data["userTypeID"] = this.userTypeID;
        data["accessLevel"] = this.accessLevel;
        return data;
    }
}
export class AccessLevelResponse {
    accessLevelID;
    accessLevel;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.accessLevelID = _data["accessLevelID"];
            this.accessLevel = _data["accessLevel"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new AccessLevelResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["accessLevelID"] = this.accessLevelID;
        data["accessLevel"] = this.accessLevel;
        return data;
    }
}
export class AreaResponse {
    id;
    name;
    geographicalName;
    costumerID;
    initiallyCreated;
    lastUpdated;
    defaultChargeAmount;
    showInParkAdmin;
    subAreas;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.subAreas = [];
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.geographicalName = _data["geographicalName"];
            this.costumerID = _data["costumerID"];
            this.initiallyCreated = _data["initiallyCreated"];
            this.lastUpdated = _data["lastUpdated"];
            this.defaultChargeAmount = _data["defaultChargeAmount"];
            this.showInParkAdmin = _data["showInParkAdmin"];
            if (Array.isArray(_data["subAreas"])) {
                this.subAreas = [];
                for (let item of _data["subAreas"])
                    this.subAreas.push(SubAreaResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new AreaResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["geographicalName"] = this.geographicalName;
        data["costumerID"] = this.costumerID;
        data["initiallyCreated"] = this.initiallyCreated;
        data["lastUpdated"] = this.lastUpdated;
        data["defaultChargeAmount"] = this.defaultChargeAmount;
        data["showInParkAdmin"] = this.showInParkAdmin;
        if (Array.isArray(this.subAreas)) {
            data["subAreas"] = [];
            for (let item of this.subAreas)
                data["subAreas"].push(item.toJSON());
        }
        return data;
    }
}
export class AreaSimplifiedResponse {
    id;
    name;
    geographicalName;
    costumerID;
    defaultChargeAmount;
    subAreas;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.subAreas = [];
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.geographicalName = _data["geographicalName"];
            this.costumerID = _data["costumerID"];
            this.defaultChargeAmount = _data["defaultChargeAmount"];
            if (Array.isArray(_data["subAreas"])) {
                this.subAreas = [];
                for (let item of _data["subAreas"])
                    this.subAreas.push(SubAreaResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new AreaSimplifiedResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["geographicalName"] = this.geographicalName;
        data["costumerID"] = this.costumerID;
        data["defaultChargeAmount"] = this.defaultChargeAmount;
        if (Array.isArray(this.subAreas)) {
            data["subAreas"] = [];
            for (let item of this.subAreas)
                data["subAreas"].push(item.toJSON());
        }
        return data;
    }
}
export class AuthenticateResponse {
    id;
    name;
    username;
    costumerID;
    accessLevel;
    role;
    language;
    languageName;
    jwtToken;
    refreshToken;
    userTypeID;
    userType;
    modeID;
    mode;
    subscriberID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.costumerID = _data["costumerID"];
            this.accessLevel = _data["accessLevel"];
            this.role = _data["role"];
            this.language = _data["language"];
            this.languageName = _data["languageName"];
            this.jwtToken = _data["jwtToken"];
            this.refreshToken = _data["refreshToken"];
            this.userTypeID = _data["userTypeID"];
            this.userType = _data["userType"];
            this.modeID = _data["modeID"];
            this.mode = _data["mode"];
            this.subscriberID = _data["subscriberID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new AuthenticateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["username"] = this.username;
        data["costumerID"] = this.costumerID;
        data["accessLevel"] = this.accessLevel;
        data["role"] = this.role;
        data["language"] = this.language;
        data["languageName"] = this.languageName;
        data["jwtToken"] = this.jwtToken;
        data["refreshToken"] = this.refreshToken;
        data["userTypeID"] = this.userTypeID;
        data["userType"] = this.userType;
        data["modeID"] = this.modeID;
        data["mode"] = this.mode;
        data["subscriberID"] = this.subscriberID;
        return data;
    }
}
export class CarResponse {
    id;
    name;
    licensePlate;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.licensePlate = _data["licensePlate"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new CarResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["licensePlate"] = this.licensePlate;
        return data;
    }
}
export class ChargeTemplateResponse {
    templateID;
    costumerID;
    template;
    initiallyCreated;
    lastUpdated;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.templateID = _data["templateID"];
            this.costumerID = _data["costumerID"];
            this.template = _data["template"];
            this.initiallyCreated = _data["initiallyCreated"];
            this.lastUpdated = _data["lastUpdated"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ChargeTemplateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["templateID"] = this.templateID;
        data["costumerID"] = this.costumerID;
        data["template"] = this.template;
        data["initiallyCreated"] = this.initiallyCreated;
        data["lastUpdated"] = this.lastUpdated;
        return data;
    }
}
export class CostumerResponse {
    costumerID;
    costumerName;
    emailConfig;
    prsAreaManager;
    prsCompanyID;
    hasParkPay;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.costumerID = _data["costumerID"];
            this.costumerName = _data["costumerName"];
            this.emailConfig = _data["emailConfig"];
            this.prsAreaManager = _data["prsAreaManager"];
            this.prsCompanyID = _data["prsCompanyID"];
            this.hasParkPay = _data["hasParkPay"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new CostumerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["costumerID"] = this.costumerID;
        data["costumerName"] = this.costumerName;
        data["emailConfig"] = this.emailConfig;
        data["prsAreaManager"] = this.prsAreaManager;
        data["prsCompanyID"] = this.prsCompanyID;
        data["hasParkPay"] = this.hasParkPay;
        return data;
    }
}
export class EmailConfigurationResponse {
    costumerID;
    emailTemplateTypeID;
    emailTemplateType;
    emailSendingStateID;
    emailSendingState;
    defaultTemplate;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.costumerID = _data["costumerID"];
            this.emailTemplateTypeID = _data["emailTemplateTypeID"];
            this.emailTemplateType = _data["emailTemplateType"];
            this.emailSendingStateID = _data["emailSendingStateID"];
            this.emailSendingState = _data["emailSendingState"];
            this.defaultTemplate = _data["defaultTemplate"]
                ? EmailTemplateResponse.fromJS(_data["defaultTemplate"])
                : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailConfigurationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["costumerID"] = this.costumerID;
        data["emailTemplateTypeID"] = this.emailTemplateTypeID;
        data["emailTemplateType"] = this.emailTemplateType;
        data["emailSendingStateID"] = this.emailSendingStateID;
        data["emailSendingState"] = this.emailSendingState;
        data["defaultTemplate"] = this.defaultTemplate ? this.defaultTemplate.toJSON() : undefined;
        return data;
    }
}
export class EmailSendingStateResponse {
    emailSendingStateID;
    emailSendingState;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailSendingStateID = _data["emailSendingStateID"];
            this.emailSendingState = _data["emailSendingState"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailSendingStateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["emailSendingStateID"] = this.emailSendingStateID;
        data["emailSendingState"] = this.emailSendingState;
        return data;
    }
}
export class EmailTemplateResponse {
    id;
    emailTemplateName;
    costumerID;
    emailTemplateTypeName;
    emailTemplateType;
    subject;
    config;
    signatureLogo;
    paragraphs;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.emailTemplateName = _data["emailTemplateName"];
            this.costumerID = _data["costumerID"];
            this.emailTemplateTypeName = _data["emailTemplateTypeName"];
            this.emailTemplateType = _data["emailTemplateType"];
            this.subject = _data["subject"];
            this.config = _data["config"];
            this.signatureLogo = _data["signatureLogo"];
            if (Array.isArray(_data["paragraphs"])) {
                this.paragraphs = [];
                for (let item of _data["paragraphs"])
                    this.paragraphs.push(ParagraphResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailTemplateResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["emailTemplateName"] = this.emailTemplateName;
        data["costumerID"] = this.costumerID;
        data["emailTemplateTypeName"] = this.emailTemplateTypeName;
        data["emailTemplateType"] = this.emailTemplateType;
        data["subject"] = this.subject;
        data["config"] = this.config;
        data["signatureLogo"] = this.signatureLogo;
        if (Array.isArray(this.paragraphs)) {
            data["paragraphs"] = [];
            for (let item of this.paragraphs)
                data["paragraphs"].push(item.toJSON());
        }
        return data;
    }
}
export class EmailTemplateTypes {
    emailTemplateTypeID;
    emailTemplateType;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.emailTemplateTypeID = _data["emailTemplateTypeID"];
            this.emailTemplateType = _data["emailTemplateType"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EmailTemplateTypes();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["emailTemplateTypeID"] = this.emailTemplateTypeID;
        data["emailTemplateType"] = this.emailTemplateType;
        return data;
    }
}
export class EventTextResponse {
    eventTextID;
    costumerID;
    editEventID;
    languageCodeID;
    text;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.eventTextID = _data["eventTextID"];
            this.costumerID = _data["costumerID"];
            this.editEventID = _data["editEventID"];
            this.languageCodeID = _data["languageCodeID"];
            this.text = _data["text"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new EventTextResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["eventTextID"] = this.eventTextID;
        data["costumerID"] = this.costumerID;
        data["editEventID"] = this.editEventID;
        data["languageCodeID"] = this.languageCodeID;
        data["text"] = this.text;
        return data;
    }
}
export class FeatureResponse {
    featureID;
    feature;
    description;
    active;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.featureID = _data["featureID"];
            this.feature = _data["feature"];
            this.description = _data["description"];
            this.active = _data["active"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new FeatureResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["featureID"] = this.featureID;
        data["feature"] = this.feature;
        data["description"] = this.description;
        data["active"] = this.active;
        return data;
    }
}
export class FeatureToggleResponse {
    featureID;
    feature;
    description;
    active;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.featureID = _data["featureID"];
            this.feature = _data["feature"];
            this.description = _data["description"];
            this.active = _data["active"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new FeatureToggleResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["featureID"] = this.featureID;
        data["feature"] = this.feature;
        data["description"] = this.description;
        data["active"] = this.active;
        return data;
    }
}
export class ImageResponse {
    imagePath;
    imageSource;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.imagePath = _data["imagePath"];
            this.imageSource = _data["imageSource"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ImageResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["imagePath"] = this.imagePath;
        data["imageSource"] = this.imageSource;
        return data;
    }
}
export class MailResponse {
    mailID;
    recipient;
    subject;
    body;
    emailTemplateType;
    expectedSendTime;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.mailID = _data["mailID"];
            this.recipient = _data["recipient"];
            this.subject = _data["subject"];
            this.body = _data["body"];
            this.emailTemplateType = _data["emailTemplateType"];
            this.expectedSendTime = _data["expectedSendTime"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new MailResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["mailID"] = this.mailID;
        data["recipient"] = this.recipient;
        data["subject"] = this.subject;
        data["body"] = this.body;
        data["emailTemplateType"] = this.emailTemplateType;
        data["expectedSendTime"] = this.expectedSendTime;
        return data;
    }
}
export class MaskableEntityResponse {
    maskableEntityID;
    maskableEntity;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.maskableEntityID = _data["maskableEntityID"];
            this.maskableEntity = _data["maskableEntity"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new MaskableEntityResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["maskableEntityID"] = this.maskableEntityID;
        data["maskableEntity"] = this.maskableEntity;
        return data;
    }
}
export class MaskingActionResponse {
    maskingActionID;
    maskingAction;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.maskingActionID = _data["maskingActionID"];
            this.maskingAction = _data["maskingAction"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new MaskingActionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["maskingActionID"] = this.maskingActionID;
        data["maskingAction"] = this.maskingAction;
        return data;
    }
}
export class ModeConfigurationResponse {
    modeConfigurationID;
    subscriptonTypeID;
    welcomeEmailEmplateID;
    headerLogo;
    footerLogo;
    areas;
    features;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.modeConfigurationID = _data["modeConfigurationID"];
            this.subscriptonTypeID = _data["subscriptonTypeID"];
            this.welcomeEmailEmplateID = _data["welcomeEmailEmplateID"];
            this.headerLogo = _data["headerLogo"];
            this.footerLogo = _data["footerLogo"];
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaResponse.fromJS(item));
            }
            if (Array.isArray(_data["features"])) {
                this.features = [];
                for (let item of _data["features"])
                    this.features.push(FeatureResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ModeConfigurationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["modeConfigurationID"] = this.modeConfigurationID;
        data["subscriptonTypeID"] = this.subscriptonTypeID;
        data["welcomeEmailEmplateID"] = this.welcomeEmailEmplateID;
        data["headerLogo"] = this.headerLogo;
        data["footerLogo"] = this.footerLogo;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.features)) {
            data["features"] = [];
            for (let item of this.features)
                data["features"].push(item.toJSON());
        }
        return data;
    }
}
export class ModeResponse {
    modeID;
    mode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.modeID = _data["modeID"];
            this.mode = _data["mode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ModeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["modeID"] = this.modeID;
        data["mode"] = this.mode;
        return data;
    }
}
export class ParagraphResponse {
    id;
    costumerID;
    title;
    body;
    order;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.costumerID = _data["costumerID"];
            this.title = _data["title"];
            this.body = _data["body"];
            this.order = _data["order"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParagraphResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["costumerID"] = this.costumerID;
        data["title"] = this.title;
        data["body"] = this.body;
        data["order"] = this.order;
        return data;
    }
}
export class ParkingResponse {
    parkingID;
    costumerID;
    areaID;
    subscriberID;
    subscriptionID;
    externalParkingRightID;
    costumerInfo;
    purchased;
    validityBegin;
    parkingRightType;
    departed;
    reconciledTo;
    validityEnd;
    area;
    vehicleIdents;
    initiallyCreated;
    lastUpdated;
    isManuallyAccepted;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.parkingID = _data["parkingID"];
            this.costumerID = _data["costumerID"];
            this.areaID = _data["areaID"];
            this.subscriberID = _data["subscriberID"];
            this.subscriptionID = _data["subscriptionID"];
            this.externalParkingRightID = _data["externalParkingRightID"];
            this.costumerInfo = _data["costumerInfo"];
            this.purchased = _data["purchased"];
            this.validityBegin = _data["validityBegin"];
            this.parkingRightType = _data["parkingRightType"];
            this.departed = _data["departed"];
            this.reconciledTo = _data["reconciledTo"];
            this.validityEnd = _data["validityEnd"];
            this.area = _data["area"] ? AreaSimplifiedResponse.fromJS(_data["area"]) : undefined;
            if (Array.isArray(_data["vehicleIdents"])) {
                this.vehicleIdents = [];
                for (let item of _data["vehicleIdents"])
                    this.vehicleIdents.push(item);
            }
            this.initiallyCreated = _data["initiallyCreated"];
            this.lastUpdated = _data["lastUpdated"];
            this.isManuallyAccepted = _data["isManuallyAccepted"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["parkingID"] = this.parkingID;
        data["costumerID"] = this.costumerID;
        data["areaID"] = this.areaID;
        data["subscriberID"] = this.subscriberID;
        data["subscriptionID"] = this.subscriptionID;
        data["externalParkingRightID"] = this.externalParkingRightID;
        data["costumerInfo"] = this.costumerInfo;
        data["purchased"] = this.purchased;
        data["validityBegin"] = this.validityBegin;
        data["parkingRightType"] = this.parkingRightType;
        data["departed"] = this.departed;
        data["reconciledTo"] = this.reconciledTo;
        data["validityEnd"] = this.validityEnd;
        data["area"] = this.area ? this.area.toJSON() : undefined;
        if (Array.isArray(this.vehicleIdents)) {
            data["vehicleIdents"] = [];
            for (let item of this.vehicleIdents)
                data["vehicleIdents"].push(item);
        }
        data["initiallyCreated"] = this.initiallyCreated;
        data["lastUpdated"] = this.lastUpdated;
        data["isManuallyAccepted"] = this.isManuallyAccepted;
        return data;
    }
}
export class ParkingSearchResponse {
    id;
    entityType;
    costumerID;
    subscriberID;
    subscriptionID;
    start;
    stop;
    reconciledTo;
    existsInParkPay;
    vehicleIdents;
    prsTags;
    area;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.entityType = _data["entityType"];
            this.costumerID = _data["costumerID"];
            this.subscriberID = _data["subscriberID"];
            this.subscriptionID = _data["subscriptionID"];
            this.start = _data["start"];
            this.stop = _data["stop"];
            this.reconciledTo = _data["reconciledTo"];
            this.existsInParkPay = _data["existsInParkPay"];
            if (Array.isArray(_data["vehicleIdents"])) {
                this.vehicleIdents = [];
                for (let item of _data["vehicleIdents"])
                    this.vehicleIdents.push(item);
            }
            if (Array.isArray(_data["prsTags"])) {
                this.prsTags = [];
                for (let item of _data["prsTags"])
                    this.prsTags.push(PrsTagResponse.fromJS(item));
            }
            this.area = _data["area"] ? AreaResponse.fromJS(_data["area"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingSearchResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["entityType"] = this.entityType;
        data["costumerID"] = this.costumerID;
        data["subscriberID"] = this.subscriberID;
        data["subscriptionID"] = this.subscriptionID;
        data["start"] = this.start;
        data["stop"] = this.stop;
        data["reconciledTo"] = this.reconciledTo;
        data["existsInParkPay"] = this.existsInParkPay;
        if (Array.isArray(this.vehicleIdents)) {
            data["vehicleIdents"] = [];
            for (let item of this.vehicleIdents)
                data["vehicleIdents"].push(item);
        }
        if (Array.isArray(this.prsTags)) {
            data["prsTags"] = [];
            for (let item of this.prsTags)
                data["prsTags"].push(item.toJSON());
        }
        data["area"] = this.area ? this.area.toJSON() : undefined;
        return data;
    }
}
export class ParkingSystemResponse {
    name;
    parkingSystemTranslations;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["parkingSystemTranslations"])) {
                this.parkingSystemTranslations = [];
                for (let item of _data["parkingSystemTranslations"])
                    this.parkingSystemTranslations.push(ParkingSystemTranslationResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingSystemResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.parkingSystemTranslations)) {
            data["parkingSystemTranslations"] = [];
            for (let item of this.parkingSystemTranslations)
                data["parkingSystemTranslations"].push(item.toJSON());
        }
        return data;
    }
}
export class ParkingSystemTranslationResponse {
    translatedName;
    languageCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.translatedName = _data["translatedName"];
            this.languageCode = _data["languageCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingSystemTranslationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["translatedName"] = this.translatedName;
        data["languageCode"] = this.languageCode;
        return data;
    }
}
export class ParkingTaggerResponse {
    logosID;
    costumerID;
    lookupAndValidateDNK;
    lookupAndValidateNOR;
    duration1Enabled;
    duration1Value;
    duration2Enabled;
    duration2Value;
    duration3Enabled;
    duration3Value;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.logosID = _data["logosID"];
            this.costumerID = _data["costumerID"];
            this.lookupAndValidateDNK = _data["lookupAndValidateDNK"];
            this.lookupAndValidateNOR = _data["lookupAndValidateNOR"];
            this.duration1Enabled = _data["duration1Enabled"];
            this.duration1Value = _data["duration1Value"];
            this.duration2Enabled = _data["duration2Enabled"];
            this.duration2Value = _data["duration2Value"];
            this.duration3Enabled = _data["duration3Enabled"];
            this.duration3Value = _data["duration3Value"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingTaggerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["logosID"] = this.logosID;
        data["costumerID"] = this.costumerID;
        data["lookupAndValidateDNK"] = this.lookupAndValidateDNK;
        data["lookupAndValidateNOR"] = this.lookupAndValidateNOR;
        data["duration1Enabled"] = this.duration1Enabled;
        data["duration1Value"] = this.duration1Value;
        data["duration2Enabled"] = this.duration2Enabled;
        data["duration2Value"] = this.duration2Value;
        data["duration3Enabled"] = this.duration3Enabled;
        data["duration3Value"] = this.duration3Value;
        return data;
    }
}
export class ParkingTypeResponse {
    name;
    parkingTypeTranslations;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["parkingTypeTranslations"])) {
                this.parkingTypeTranslations = [];
                for (let item of _data["parkingTypeTranslations"])
                    this.parkingTypeTranslations.push(ParkingTypeTranslationResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingTypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.parkingTypeTranslations)) {
            data["parkingTypeTranslations"] = [];
            for (let item of this.parkingTypeTranslations)
                data["parkingTypeTranslations"].push(item.toJSON());
        }
        return data;
    }
}
export class ParkingTypeTranslationResponse {
    translatedName;
    languageCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.translatedName = _data["translatedName"];
            this.languageCode = _data["languageCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingTypeTranslationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["translatedName"] = this.translatedName;
        data["languageCode"] = this.languageCode;
        return data;
    }
}
export class PrsTagResponse {
    name;
    prsTagTranslations;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
            if (Array.isArray(_data["prsTagTranslations"])) {
                this.prsTagTranslations = [];
                for (let item of _data["prsTagTranslations"])
                    this.prsTagTranslations.push(PrsTagTranslationResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PrsTagResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        if (Array.isArray(this.prsTagTranslations)) {
            data["prsTagTranslations"] = [];
            for (let item of this.prsTagTranslations)
                data["prsTagTranslations"].push(item.toJSON());
        }
        return data;
    }
}
export class PrsTagTranslationResponse {
    translatedName;
    languageCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.translatedName = _data["translatedName"];
            this.languageCode = _data["languageCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PrsTagTranslationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["translatedName"] = this.translatedName;
        data["languageCode"] = this.languageCode;
        return data;
    }
}
export class QrCodeResponse {
    base64;
    from;
    to;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.base64 = _data["base64"];
            this.from = _data["from"];
            this.to = _data["to"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new QrCodeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["base64"] = this.base64;
        data["from"] = this.from;
        data["to"] = this.to;
        return data;
    }
}
export class SensitiveDataConfigurationResponse {
    maskableEntityID;
    maskableEntity;
    maskingActionID;
    maskingAction;
    lifeTime;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.maskableEntityID = _data["maskableEntityID"];
            this.maskableEntity = _data["maskableEntity"];
            this.maskingActionID = _data["maskingActionID"];
            this.maskingAction = _data["maskingAction"];
            this.lifeTime = _data["lifeTime"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SensitiveDataConfigurationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["maskableEntityID"] = this.maskableEntityID;
        data["maskableEntity"] = this.maskableEntity;
        data["maskingActionID"] = this.maskingActionID;
        data["maskingAction"] = this.maskingAction;
        data["lifeTime"] = this.lifeTime;
        return data;
    }
}
export class StatisticsActivityGraphsResponse {
    activityGraph;
    activityPerWeekdayGraph;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["activityGraph"])) {
                this.activityGraph = [];
                for (let item of _data["activityGraph"])
                    this.activityGraph.push(StatisticsIntervalResponse.fromJS(item));
            }
            if (Array.isArray(_data["activityPerWeekdayGraph"])) {
                this.activityPerWeekdayGraph = [];
                for (let item of _data["activityPerWeekdayGraph"])
                    this.activityPerWeekdayGraph.push(StatisticsWeekdayResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsActivityGraphsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.activityGraph)) {
            data["activityGraph"] = [];
            for (let item of this.activityGraph)
                data["activityGraph"].push(item.toJSON());
        }
        if (Array.isArray(this.activityPerWeekdayGraph)) {
            data["activityPerWeekdayGraph"] = [];
            for (let item of this.activityPerWeekdayGraph)
                data["activityPerWeekdayGraph"].push(item.toJSON());
        }
        return data;
    }
}
export class StatisticsDurationGraphsResponse {
    durationGraph;
    durationPerWeekdayGraph;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["durationGraph"])) {
                this.durationGraph = [];
                for (let item of _data["durationGraph"])
                    this.durationGraph.push(StatisticsIntervalResponse.fromJS(item));
            }
            if (Array.isArray(_data["durationPerWeekdayGraph"])) {
                this.durationPerWeekdayGraph = [];
                for (let item of _data["durationPerWeekdayGraph"])
                    this.durationPerWeekdayGraph.push(StatisticsWeekdayResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsDurationGraphsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.durationGraph)) {
            data["durationGraph"] = [];
            for (let item of this.durationGraph)
                data["durationGraph"].push(item.toJSON());
        }
        if (Array.isArray(this.durationPerWeekdayGraph)) {
            data["durationPerWeekdayGraph"] = [];
            for (let item of this.durationPerWeekdayGraph)
                data["durationPerWeekdayGraph"].push(item.toJSON());
        }
        return data;
    }
}
export class StatisticsIntervalResponse {
    from;
    to;
    fromDayOfWeek;
    toDayOfWeek;
    fromDay;
    toDay;
    fromDurationInMinutes;
    toDurationInMinutes;
    fromWeek;
    toWeek;
    fromMonth;
    toMonth;
    numberOfParkings;
    numberOfArrivals;
    numberOfDepartures;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.from = _data["from"];
            this.to = _data["to"];
            this.fromDayOfWeek = _data["fromDayOfWeek"];
            this.toDayOfWeek = _data["toDayOfWeek"];
            this.fromDay = _data["fromDay"];
            this.toDay = _data["toDay"];
            this.fromDurationInMinutes = _data["fromDurationInMinutes"];
            this.toDurationInMinutes = _data["toDurationInMinutes"];
            this.fromWeek = _data["fromWeek"];
            this.toWeek = _data["toWeek"];
            this.fromMonth = _data["fromMonth"];
            this.toMonth = _data["toMonth"];
            this.numberOfParkings = _data["numberOfParkings"];
            this.numberOfArrivals = _data["numberOfArrivals"];
            this.numberOfDepartures = _data["numberOfDepartures"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsIntervalResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["from"] = this.from;
        data["to"] = this.to;
        data["fromDayOfWeek"] = this.fromDayOfWeek;
        data["toDayOfWeek"] = this.toDayOfWeek;
        data["fromDay"] = this.fromDay;
        data["toDay"] = this.toDay;
        data["fromDurationInMinutes"] = this.fromDurationInMinutes;
        data["toDurationInMinutes"] = this.toDurationInMinutes;
        data["fromWeek"] = this.fromWeek;
        data["toWeek"] = this.toWeek;
        data["fromMonth"] = this.fromMonth;
        data["toMonth"] = this.toMonth;
        data["numberOfParkings"] = this.numberOfParkings;
        data["numberOfArrivals"] = this.numberOfArrivals;
        data["numberOfDepartures"] = this.numberOfDepartures;
        return data;
    }
}
export class StatisticsOccupancyGraphsResponse {
    averageOccupancyGraph;
    averageOccupancyPerWeekdayGraph;
    occupancyGraph;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["averageOccupancyGraph"])) {
                this.averageOccupancyGraph = [];
                for (let item of _data["averageOccupancyGraph"])
                    this.averageOccupancyGraph.push(StatisticsIntervalResponse.fromJS(item));
            }
            if (Array.isArray(_data["averageOccupancyPerWeekdayGraph"])) {
                this.averageOccupancyPerWeekdayGraph = [];
                for (let item of _data["averageOccupancyPerWeekdayGraph"])
                    this.averageOccupancyPerWeekdayGraph.push(StatisticsWeekdayResponse.fromJS(item));
            }
            if (Array.isArray(_data["occupancyGraph"])) {
                this.occupancyGraph = [];
                for (let item of _data["occupancyGraph"])
                    this.occupancyGraph.push(StatisticsIntervalResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsOccupancyGraphsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.averageOccupancyGraph)) {
            data["averageOccupancyGraph"] = [];
            for (let item of this.averageOccupancyGraph)
                data["averageOccupancyGraph"].push(item.toJSON());
        }
        if (Array.isArray(this.averageOccupancyPerWeekdayGraph)) {
            data["averageOccupancyPerWeekdayGraph"] = [];
            for (let item of this.averageOccupancyPerWeekdayGraph)
                data["averageOccupancyPerWeekdayGraph"].push(item.toJSON());
        }
        if (Array.isArray(this.occupancyGraph)) {
            data["occupancyGraph"] = [];
            for (let item of this.occupancyGraph)
                data["occupancyGraph"].push(item.toJSON());
        }
        return data;
    }
}
export class StatisticsResponse {
    statisticsSummary;
    statisticsDurationGraphs;
    statisticsActivityGraphs;
    statisticsOccupancyGraphs;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.statisticsSummary = _data["statisticsSummary"]
                ? StatisticsSummaryResponse.fromJS(_data["statisticsSummary"])
                : undefined;
            this.statisticsDurationGraphs = _data["statisticsDurationGraphs"]
                ? StatisticsDurationGraphsResponse.fromJS(_data["statisticsDurationGraphs"])
                : undefined;
            this.statisticsActivityGraphs = _data["statisticsActivityGraphs"]
                ? StatisticsActivityGraphsResponse.fromJS(_data["statisticsActivityGraphs"])
                : undefined;
            this.statisticsOccupancyGraphs = _data["statisticsOccupancyGraphs"]
                ? StatisticsOccupancyGraphsResponse.fromJS(_data["statisticsOccupancyGraphs"])
                : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["statisticsSummary"] = this.statisticsSummary
            ? this.statisticsSummary.toJSON()
            : undefined;
        data["statisticsDurationGraphs"] = this.statisticsDurationGraphs
            ? this.statisticsDurationGraphs.toJSON()
            : undefined;
        data["statisticsActivityGraphs"] = this.statisticsActivityGraphs
            ? this.statisticsActivityGraphs.toJSON()
            : undefined;
        data["statisticsOccupancyGraphs"] = this.statisticsOccupancyGraphs
            ? this.statisticsOccupancyGraphs.toJSON()
            : undefined;
        return data;
    }
}
export class StatisticsSummaryResponse {
    totalNumberOfParkings;
    averageParkingTimeInMinutes;
    totalParkingTimeInHours;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalNumberOfParkings = _data["totalNumberOfParkings"];
            this.averageParkingTimeInMinutes = _data["averageParkingTimeInMinutes"];
            this.totalParkingTimeInHours = _data["totalParkingTimeInHours"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["totalNumberOfParkings"] = this.totalNumberOfParkings;
        data["averageParkingTimeInMinutes"] = this.averageParkingTimeInMinutes;
        data["totalParkingTimeInHours"] = this.totalParkingTimeInHours;
        return data;
    }
}
export class StatisticsWeekdayResponse {
    dayOfWeek;
    dayOfWeekAsNumber;
    graphIntervals;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.dayOfWeek = _data["dayOfWeek"];
            this.dayOfWeekAsNumber = _data["dayOfWeekAsNumber"];
            if (Array.isArray(_data["graphIntervals"])) {
                this.graphIntervals = [];
                for (let item of _data["graphIntervals"])
                    this.graphIntervals.push(StatisticsIntervalResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new StatisticsWeekdayResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["dayOfWeek"] = this.dayOfWeek;
        data["dayOfWeekAsNumber"] = this.dayOfWeekAsNumber;
        if (Array.isArray(this.graphIntervals)) {
            data["graphIntervals"] = [];
            for (let item of this.graphIntervals)
                data["graphIntervals"].push(item.toJSON());
        }
        return data;
    }
}
export class SubAreaResponse {
    id;
    name;
    geographicalName;
    softLimit;
    hardLimit;
    showInParkAdmin;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.geographicalName = _data["geographicalName"];
            this.softLimit = _data["softLimit"];
            this.hardLimit = _data["hardLimit"];
            this.showInParkAdmin = _data["showInParkAdmin"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubAreaResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["geographicalName"] = this.geographicalName;
        data["softLimit"] = this.softLimit;
        data["hardLimit"] = this.hardLimit;
        data["showInParkAdmin"] = this.showInParkAdmin;
        return data;
    }
}
export class SubscriberResponse {
    id;
    firstName;
    lastName;
    subscriberType;
    subscriberTypeName;
    email;
    remark;
    phonenumber;
    address1;
    address2;
    district;
    city;
    zipCode;
    country;
    name;
    cvr;
    attPersonName;
    active;
    recieveNewsLetter;
    externalCostumerID;
    defaultWelcomeEmailID;
    modesEnabled;
    initiallyCreated;
    lastUpdated;
    hasBeenMasked;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.subscriberType = _data["subscriberType"];
            this.subscriberTypeName = _data["subscriberTypeName"];
            this.email = _data["email"];
            this.remark = _data["remark"];
            this.phonenumber = _data["phonenumber"];
            this.address1 = _data["address1"];
            this.address2 = _data["address2"];
            this.district = _data["district"];
            this.city = _data["city"];
            this.zipCode = _data["zipCode"];
            this.country = _data["country"];
            this.name = _data["name"];
            this.cvr = _data["cvr"];
            this.attPersonName = _data["attPersonName"];
            this.active = _data["active"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.externalCostumerID = _data["externalCostumerID"];
            this.defaultWelcomeEmailID = _data["defaultWelcomeEmailID"];
            if (Array.isArray(_data["modesEnabled"])) {
                this.modesEnabled = [];
                for (let item of _data["modesEnabled"])
                    this.modesEnabled.push(ModeResponse.fromJS(item));
            }
            this.initiallyCreated = _data["initiallyCreated"];
            this.lastUpdated = _data["lastUpdated"];
            this.hasBeenMasked = _data["hasBeenMasked"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriberResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["subscriberType"] = this.subscriberType;
        data["subscriberTypeName"] = this.subscriberTypeName;
        data["email"] = this.email;
        data["remark"] = this.remark;
        data["phonenumber"] = this.phonenumber;
        data["address1"] = this.address1;
        data["address2"] = this.address2;
        data["district"] = this.district;
        data["city"] = this.city;
        data["zipCode"] = this.zipCode;
        data["country"] = this.country;
        data["name"] = this.name;
        data["cvr"] = this.cvr;
        data["attPersonName"] = this.attPersonName;
        data["active"] = this.active;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["externalCostumerID"] = this.externalCostumerID;
        data["defaultWelcomeEmailID"] = this.defaultWelcomeEmailID;
        if (Array.isArray(this.modesEnabled)) {
            data["modesEnabled"] = [];
            for (let item of this.modesEnabled)
                data["modesEnabled"].push(item.toJSON());
        }
        data["initiallyCreated"] = this.initiallyCreated;
        data["lastUpdated"] = this.lastUpdated;
        data["hasBeenMasked"] = this.hasBeenMasked;
        return data;
    }
}
export class SubscriptionCarHistoryResponse {
    carId;
    subscriptionId;
    active;
    licenseplate;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.carId = _data["carId"];
            this.subscriptionId = _data["subscriptionId"];
            this.active = _data["active"];
            this.licenseplate = _data["licenseplate"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionCarHistoryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["carId"] = this.carId;
        data["subscriptionId"] = this.subscriptionId;
        data["active"] = this.active;
        data["licenseplate"] = this.licenseplate;
        return data;
    }
}
export class SubscriptionHistoryResponse {
    id;
    name;
    email;
    fromDate;
    toDate;
    active;
    recieveNewsLetter;
    phonenumber;
    remark;
    primaryArea;
    subscriptionType;
    areas;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.active = _data["active"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.phonenumber = _data["phonenumber"];
            this.remark = _data["remark"];
            this.primaryArea = _data["primaryArea"]
                ? AreaResponse.fromJS(_data["primaryArea"])
                : undefined;
            this.subscriptionType = _data["subscriptionType"]
                ? SubscriptionTypeResponse.fromJS(_data["subscriptionType"])
                : undefined;
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionHistoryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["active"] = this.active;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["phonenumber"] = this.phonenumber;
        data["remark"] = this.remark;
        data["primaryArea"] = this.primaryArea ? this.primaryArea.toJSON() : undefined;
        data["subscriptionType"] = this.subscriptionType
            ? this.subscriptionType.toJSON()
            : undefined;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        return data;
    }
}
export class SubscriptionResponse {
    id;
    name;
    email;
    primaryArea;
    fromDate;
    toDate;
    active;
    recieveNewsLetter;
    phonenumber;
    remark;
    subscriberID;
    subscriberName;
    subscriptionType;
    areas;
    cars;
    initiallyCreated;
    lastUpdated;
    hasBeenMasked;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.primaryArea = new AreaResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.email = _data["email"];
            this.primaryArea = _data["primaryArea"]
                ? AreaResponse.fromJS(_data["primaryArea"])
                : new AreaResponse();
            this.fromDate = _data["fromDate"];
            this.toDate = _data["toDate"];
            this.active = _data["active"];
            this.recieveNewsLetter = _data["recieveNewsLetter"];
            this.phonenumber = _data["phonenumber"];
            this.remark = _data["remark"];
            this.subscriberID = _data["subscriberID"];
            this.subscriberName = _data["subscriberName"];
            this.subscriptionType = _data["subscriptionType"]
                ? SubscriptionTypeResponse.fromJS(_data["subscriptionType"])
                : undefined;
            if (Array.isArray(_data["areas"])) {
                this.areas = [];
                for (let item of _data["areas"])
                    this.areas.push(AreaResponse.fromJS(item));
            }
            if (Array.isArray(_data["cars"])) {
                this.cars = [];
                for (let item of _data["cars"])
                    this.cars.push(CarResponse.fromJS(item));
            }
            this.initiallyCreated = _data["initiallyCreated"];
            this.lastUpdated = _data["lastUpdated"];
            this.hasBeenMasked = _data["hasBeenMasked"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["email"] = this.email;
        data["primaryArea"] = this.primaryArea ? this.primaryArea.toJSON() : undefined;
        data["fromDate"] = this.fromDate;
        data["toDate"] = this.toDate;
        data["active"] = this.active;
        data["recieveNewsLetter"] = this.recieveNewsLetter;
        data["phonenumber"] = this.phonenumber;
        data["remark"] = this.remark;
        data["subscriberID"] = this.subscriberID;
        data["subscriberName"] = this.subscriberName;
        data["subscriptionType"] = this.subscriptionType
            ? this.subscriptionType.toJSON()
            : undefined;
        if (Array.isArray(this.areas)) {
            data["areas"] = [];
            for (let item of this.areas)
                data["areas"].push(item.toJSON());
        }
        if (Array.isArray(this.cars)) {
            data["cars"] = [];
            for (let item of this.cars)
                data["cars"].push(item.toJSON());
        }
        data["initiallyCreated"] = this.initiallyCreated;
        data["lastUpdated"] = this.lastUpdated;
        data["hasBeenMasked"] = this.hasBeenMasked;
        return data;
    }
}
export class SubscriptionTypeResponse {
    subscriptionTypeId;
    subscriptionType;
    costumerID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subscriptionTypeId = _data["subscriptionTypeId"];
            this.subscriptionType = _data["subscriptionType"];
            this.costumerID = _data["costumerID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubscriptionTypeResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["subscriptionTypeId"] = this.subscriptionTypeId;
        data["subscriptionType"] = this.subscriptionType;
        data["costumerID"] = this.costumerID;
        return data;
    }
}
export class TermsOfServiceResponse {
    id;
    costumerID;
    mainTitle;
    headerLogo;
    footerLogo;
    paragraphs;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.costumerID = _data["costumerID"];
            this.mainTitle = _data["mainTitle"];
            this.headerLogo = _data["headerLogo"];
            this.footerLogo = _data["footerLogo"];
            if (Array.isArray(_data["paragraphs"])) {
                this.paragraphs = [];
                for (let item of _data["paragraphs"])
                    this.paragraphs.push(ParagraphResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new TermsOfServiceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["costumerID"] = this.costumerID;
        data["mainTitle"] = this.mainTitle;
        data["headerLogo"] = this.headerLogo;
        data["footerLogo"] = this.footerLogo;
        if (Array.isArray(this.paragraphs)) {
            data["paragraphs"] = [];
            for (let item of this.paragraphs)
                data["paragraphs"].push(item.toJSON());
        }
        return data;
    }
}
export class UnpaidParkingResponse {
    parkingRightID;
    costumerID;
    vehicleIdents;
    area;
    images;
    price;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.parkingRightID = _data["parkingRightID"];
            this.costumerID = _data["costumerID"];
            if (Array.isArray(_data["vehicleIdents"])) {
                this.vehicleIdents = [];
                for (let item of _data["vehicleIdents"])
                    this.vehicleIdents.push(item);
            }
            this.area = _data["area"] ? AreaResponse.fromJS(_data["area"]) : undefined;
            if (Array.isArray(_data["images"])) {
                this.images = [];
                for (let item of _data["images"])
                    this.images.push(ImageResponse.fromJS(item));
            }
            this.price = _data["price"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new UnpaidParkingResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["parkingRightID"] = this.parkingRightID;
        data["costumerID"] = this.costumerID;
        if (Array.isArray(this.vehicleIdents)) {
            data["vehicleIdents"] = [];
            for (let item of this.vehicleIdents)
                data["vehicleIdents"].push(item);
        }
        data["area"] = this.area ? this.area.toJSON() : undefined;
        if (Array.isArray(this.images)) {
            data["images"] = [];
            for (let item of this.images)
                data["images"].push(item.toJSON());
        }
        data["price"] = this.price;
        return data;
    }
}
export class UserResponse {
    id;
    costumerID;
    name;
    username;
    accessLevel;
    role;
    language;
    laguageName;
    userTypeID;
    userType;
    modeID;
    mode;
    subscriberID;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.costumerID = _data["costumerID"];
            this.name = _data["name"];
            this.username = _data["username"];
            this.accessLevel = _data["accessLevel"];
            this.role = _data["role"];
            this.language = _data["language"];
            this.laguageName = _data["laguageName"];
            this.userTypeID = _data["userTypeID"];
            this.userType = _data["userType"];
            this.modeID = _data["modeID"];
            this.mode = _data["mode"];
            this.subscriberID = _data["subscriberID"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new UserResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["id"] = this.id;
        data["costumerID"] = this.costumerID;
        data["name"] = this.name;
        data["username"] = this.username;
        data["accessLevel"] = this.accessLevel;
        data["role"] = this.role;
        data["language"] = this.language;
        data["laguageName"] = this.laguageName;
        data["userTypeID"] = this.userTypeID;
        data["userType"] = this.userType;
        data["modeID"] = this.modeID;
        data["mode"] = this.mode;
        data["subscriberID"] = this.subscriberID;
        return data;
    }
}
export class History_1OfOfSubscriptionCarHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    historyID;
    modifiedBy;
    modifiedByUsername;
    modifiedAt;
    modifyActionID;
    modifyAction;
    entity;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.historyID = _data["historyID"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByUsername = _data["modifiedByUsername"];
            this.modifiedAt = _data["modifiedAt"];
            this.modifyActionID = _data["modifyActionID"];
            this.modifyAction = _data["modifyAction"];
            this.entity = _data["entity"]
                ? SubscriptionCarHistoryResponse.fromJS(_data["entity"])
                : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new History_1OfOfSubscriptionCarHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["historyID"] = this.historyID;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByUsername"] = this.modifiedByUsername;
        data["modifiedAt"] = this.modifiedAt;
        data["modifyActionID"] = this.modifyActionID;
        data["modifyAction"] = this.modifyAction;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined;
        return data;
    }
}
export class History_1OfOfSubscriptionHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    historyID;
    modifiedBy;
    modifiedByUsername;
    modifiedAt;
    modifyActionID;
    modifyAction;
    entity;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.historyID = _data["historyID"];
            this.modifiedBy = _data["modifiedBy"];
            this.modifiedByUsername = _data["modifiedByUsername"];
            this.modifiedAt = _data["modifiedAt"];
            this.modifyActionID = _data["modifyActionID"];
            this.modifyAction = _data["modifyAction"];
            this.entity = _data["entity"]
                ? SubscriptionHistoryResponse.fromJS(_data["entity"])
                : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new History_1OfOfSubscriptionHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["historyID"] = this.historyID;
        data["modifiedBy"] = this.modifiedBy;
        data["modifiedByUsername"] = this.modifiedByUsername;
        data["modifiedAt"] = this.modifiedAt;
        data["modifyActionID"] = this.modifyActionID;
        data["modifyAction"] = this.modifyAction;
        data["entity"] = this.entity ? this.entity.toJSON() : undefined;
        return data;
    }
}
export class PagedResponse_1OfOfList_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    pageNumber;
    pageSize;
    firstPage;
    lastPage;
    totalPages;
    totalRecords;
    nextPage;
    previousPage;
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.firstPage = _data["firstPage"];
            this.lastPage = _data["lastPage"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.nextPage = _data["nextPage"];
            this.previousPage = _data["previousPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(CarResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PagedResponse_1OfOfList_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["firstPage"] = this.firstPage;
        data["lastPage"] = this.lastPage;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["nextPage"] = this.nextPage;
        data["previousPage"] = this.previousPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class PagedResponse_1OfOfList_1OfOfMailResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    pageNumber;
    pageSize;
    firstPage;
    lastPage;
    totalPages;
    totalRecords;
    nextPage;
    previousPage;
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.firstPage = _data["firstPage"];
            this.lastPage = _data["lastPage"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.nextPage = _data["nextPage"];
            this.previousPage = _data["previousPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(MailResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PagedResponse_1OfOfList_1OfOfMailResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["firstPage"] = this.firstPage;
        data["lastPage"] = this.lastPage;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["nextPage"] = this.nextPage;
        data["previousPage"] = this.previousPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class PagedResponse_1OfOfList_1OfOfParkingResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    pageNumber;
    pageSize;
    firstPage;
    lastPage;
    totalPages;
    totalRecords;
    nextPage;
    previousPage;
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.firstPage = _data["firstPage"];
            this.lastPage = _data["lastPage"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.nextPage = _data["nextPage"];
            this.previousPage = _data["previousPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(ParkingResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PagedResponse_1OfOfList_1OfOfParkingResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["firstPage"] = this.firstPage;
        data["lastPage"] = this.lastPage;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["nextPage"] = this.nextPage;
        data["previousPage"] = this.previousPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class PagedResponse_1OfOfList_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    pageNumber;
    pageSize;
    firstPage;
    lastPage;
    totalPages;
    totalRecords;
    nextPage;
    previousPage;
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.firstPage = _data["firstPage"];
            this.lastPage = _data["lastPage"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.nextPage = _data["nextPage"];
            this.previousPage = _data["previousPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(ParkingSearchResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PagedResponse_1OfOfList_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["firstPage"] = this.firstPage;
        data["lastPage"] = this.lastPage;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["nextPage"] = this.nextPage;
        data["previousPage"] = this.previousPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class PagedResponse_1OfOfList_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    pageNumber;
    pageSize;
    firstPage;
    lastPage;
    totalPages;
    totalRecords;
    nextPage;
    previousPage;
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.firstPage = _data["firstPage"];
            this.lastPage = _data["lastPage"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.nextPage = _data["nextPage"];
            this.previousPage = _data["previousPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SubscriberResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PagedResponse_1OfOfList_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["firstPage"] = this.firstPage;
        data["lastPage"] = this.lastPage;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["nextPage"] = this.nextPage;
        data["previousPage"] = this.previousPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class PagedResponse_1OfOfList_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    pageNumber;
    pageSize;
    firstPage;
    lastPage;
    totalPages;
    totalRecords;
    nextPage;
    previousPage;
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.pageNumber = _data["pageNumber"];
            this.pageSize = _data["pageSize"];
            this.firstPage = _data["firstPage"];
            this.lastPage = _data["lastPage"];
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.nextPage = _data["nextPage"];
            this.previousPage = _data["previousPage"];
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SubscriptionResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PagedResponse_1OfOfList_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["pageNumber"] = this.pageNumber;
        data["pageSize"] = this.pageSize;
        data["firstPage"] = this.firstPage;
        data["lastPage"] = this.lastPage;
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["nextPage"] = this.nextPage;
        data["previousPage"] = this.previousPage;
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? AreaResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfAuthenticateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? AuthenticateResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfAuthenticateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? CarResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfCarResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfChargeTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ChargeTemplateResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfChargeTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? CostumerResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfEmailConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? EmailConfigurationResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfEmailConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? EmailTemplateResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfEventTextResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? EventTextResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfEventTextResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfModeConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ModeConfigurationResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfModeConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfParagraphResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ParagraphResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfParagraphResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ParkingSearchResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfParkingSearchResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfParkingTaggerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ParkingTaggerResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfParkingTaggerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfQrCodeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? QrCodeResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfQrCodeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"]
                ? SensitiveDataConfigurationResponse.fromJS(_data["data"])
                : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfStatisticsResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? StatisticsResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfStatisticsResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? SubscriberResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfSubscriberResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? SubscriptionResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfSubscriptionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? SubscriptionTypeResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfTermsOfServiceResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? TermsOfServiceResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfTermsOfServiceResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? UserResponse.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfParkingExistsContainerAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ParkingExistsContainer.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfParkingExistsContainerAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfParkingOccupancyContainerAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? ParkingOccupancyContainer.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfParkingOccupancyContainerAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfPeriodsAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? Periods.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfPeriodsAndClientAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfIEnumerable_1OfOfParkingSystemResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(ParkingSystemResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfIEnumerable_1OfOfParkingSystemResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfIEnumerable_1OfOfParkingTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(ParkingTypeResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfIEnumerable_1OfOfParkingTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfAccessLevelResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(AccessLevelResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfAccessLevelResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(AreaResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfAreaResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(CostumerResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfCostumerResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfEmailConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(EmailConfigurationResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfEmailConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfEmailSendingStateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(EmailSendingStateResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfEmailSendingStateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(EmailTemplateResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfEmailTemplateResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfEmailTemplateTypesAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(EmailTemplateTypes.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfEmailTemplateTypesAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfEventTextResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(EventTextResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfEventTextResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfFeatureToggleResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(FeatureToggleResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfFeatureToggleResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfMaskableEntityResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(MaskableEntityResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfMaskableEntityResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfMaskingActionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(MaskingActionResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfMaskingActionResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfModeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(ModeResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfModeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfPrsTagResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(PrsTagResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfPrsTagResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SensitiveDataConfigurationResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfSensitiveDataConfigurationResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(SubscriptionTypeResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfSubscriptionTypeResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(UserResponse.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfUserResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfHistory_1OfOfSubscriptionCarHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(History_1OfOfSubscriptionCarHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfHistory_1OfOfSubscriptionCarHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfHistory_1OfOfSubscriptionHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(History_1OfOfSubscriptionHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_null.fromJS(item));
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfHistory_1OfOfSubscriptionHistoryResponseAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndAPIAnd_0AndCulture_neutralAndPublicKeyToken_nullAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfList_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["data"])) {
                this.data = [];
                for (let item of _data["data"])
                    this.data.push(item);
            }
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfList_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798eAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item);
        }
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"];
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfStringAndCoreLibAnd_0AndCulture_neutralAndPublicKeyToken_7cec85d7bea7798e();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export class Response_1OfOfPingAndUtilsAnd_0AndCulture_neutralAndPublicKeyToken_null {
    data;
    succeeded;
    errors;
    message;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.data = _data["data"] ? Ping.fromJS(_data["data"]) : undefined;
            this.succeeded = _data["succeeded"];
            if (Array.isArray(_data["errors"])) {
                this.errors = [];
                for (let item of _data["errors"])
                    this.errors.push(item);
            }
            this.message = _data["message"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Response_1OfOfPingAndUtilsAnd_0AndCulture_neutralAndPublicKeyToken_null();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["data"] = this.data ? this.data.toJSON() : undefined;
        data["succeeded"] = this.succeeded;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        data["message"] = this.message;
        return data;
    }
}
export var AccessLevel;
(function (AccessLevel) {
    AccessLevel[AccessLevel["_1"] = 1] = "_1";
    AccessLevel[AccessLevel["_2"] = 2] = "_2";
    AccessLevel[AccessLevel["_3"] = 3] = "_3";
    AccessLevel[AccessLevel["_4"] = 4] = "_4";
})(AccessLevel || (AccessLevel = {}));
export var EditEvent2;
(function (EditEvent2) {
    EditEvent2[EditEvent2["_1"] = 1] = "_1";
    EditEvent2[EditEvent2["_2"] = 2] = "_2";
    EditEvent2[EditEvent2["_3"] = 3] = "_3";
    EditEvent2[EditEvent2["_4"] = 4] = "_4";
    EditEvent2[EditEvent2["_5"] = 5] = "_5";
    EditEvent2[EditEvent2["_6"] = 6] = "_6";
    EditEvent2[EditEvent2["_7"] = 7] = "_7";
    EditEvent2[EditEvent2["_8"] = 8] = "_8";
    EditEvent2[EditEvent2["_9"] = 9] = "_9";
})(EditEvent2 || (EditEvent2 = {}));
export var EmailSendingState;
(function (EmailSendingState) {
    EmailSendingState[EmailSendingState["_1"] = 1] = "_1";
    EmailSendingState[EmailSendingState["_2"] = 2] = "_2";
    EmailSendingState[EmailSendingState["_3"] = 3] = "_3";
})(EmailSendingState || (EmailSendingState = {}));
export var EmailTemplateType;
(function (EmailTemplateType) {
    EmailTemplateType[EmailTemplateType["_1"] = 1] = "_1";
    EmailTemplateType[EmailTemplateType["_2"] = 2] = "_2";
    EmailTemplateType[EmailTemplateType["_3"] = 3] = "_3";
})(EmailTemplateType || (EmailTemplateType = {}));
export var Language;
(function (Language) {
    Language[Language["_1"] = 1] = "_1";
    Language[Language["_2"] = 2] = "_2";
})(Language || (Language = {}));
export var LanguageCode2;
(function (LanguageCode2) {
    LanguageCode2[LanguageCode2["_1"] = 1] = "_1";
    LanguageCode2[LanguageCode2["_2"] = 2] = "_2";
})(LanguageCode2 || (LanguageCode2 = {}));
export var MaskableEntity;
(function (MaskableEntity) {
    MaskableEntity[MaskableEntity["_1"] = 1] = "_1";
    MaskableEntity[MaskableEntity["_2"] = 2] = "_2";
})(MaskableEntity || (MaskableEntity = {}));
export var MaskingAction;
(function (MaskingAction) {
    MaskingAction[MaskingAction["_1"] = 1] = "_1";
    MaskingAction[MaskingAction["_2"] = 2] = "_2";
})(MaskingAction || (MaskingAction = {}));
export var Mode;
(function (Mode) {
    Mode[Mode["_1"] = 1] = "_1";
    Mode[Mode["_2"] = 2] = "_2";
    Mode[Mode["_3"] = 3] = "_3";
})(Mode || (Mode = {}));
export var ModifyAction;
(function (ModifyAction) {
    ModifyAction[ModifyAction["_1"] = 1] = "_1";
    ModifyAction[ModifyAction["_2"] = 2] = "_2";
    ModifyAction[ModifyAction["_3"] = 3] = "_3";
})(ModifyAction || (ModifyAction = {}));
export var SubscriberType;
(function (SubscriberType) {
    SubscriberType[SubscriberType["_1"] = 1] = "_1";
    SubscriberType[SubscriberType["_2"] = 2] = "_2";
})(SubscriberType || (SubscriberType = {}));
export var UserType;
(function (UserType) {
    UserType[UserType["_1"] = 1] = "_1";
    UserType[UserType["_2"] = 2] = "_2";
})(UserType || (UserType = {}));
export class Area {
    areaID;
    geographicalName;
    name;
    timeZone;
    subAreas;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.areaID = _data["areaID"];
            this.geographicalName = _data["geographicalName"];
            this.name = _data["name"];
            this.timeZone = _data["timeZone"];
            if (Array.isArray(_data["subAreas"])) {
                this.subAreas = [];
                for (let item of _data["subAreas"])
                    this.subAreas.push(SubArea.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Area();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["areaID"] = this.areaID;
        data["geographicalName"] = this.geographicalName;
        data["name"] = this.name;
        data["timeZone"] = this.timeZone;
        if (Array.isArray(this.subAreas)) {
            data["subAreas"] = [];
            for (let item of this.subAreas)
                data["subAreas"].push(item.toJSON());
        }
        return data;
    }
}
export class Ident {
    vehicleIdent;
    transliteratedVehicleIdent;
    countryCode;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.vehicleIdent = _data["vehicleIdent"];
            this.transliteratedVehicleIdent = _data["transliteratedVehicleIdent"];
            this.countryCode = _data["countryCode"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Ident();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["vehicleIdent"] = this.vehicleIdent;
        data["transliteratedVehicleIdent"] = this.transliteratedVehicleIdent;
        data["countryCode"] = this.countryCode;
        return data;
    }
}
export var Origin;
(function (Origin) {
    Origin[Origin["_10"] = 10] = "_10";
    Origin[Origin["_20"] = 20] = "_20";
})(Origin || (Origin = {}));
export class Orphan {
    orphanID;
    companyID;
    created;
    departed;
    expires;
    externalTransactionIdentification;
    vehicleIdents;
    tags;
    area;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.orphanID = _data["orphanID"];
            this.companyID = _data["companyID"];
            this.created = _data["created"];
            this.departed = _data["departed"];
            this.expires = _data["expires"];
            this.externalTransactionIdentification = _data["externalTransactionIdentification"];
            if (Array.isArray(_data["vehicleIdents"])) {
                this.vehicleIdents = [];
                for (let item of _data["vehicleIdents"])
                    this.vehicleIdents.push(Ident.fromJS(item));
            }
            if (Array.isArray(_data["tags"])) {
                this.tags = [];
                for (let item of _data["tags"])
                    this.tags.push(PrsTag.fromJS(item));
            }
            this.area = _data["area"] ? Area.fromJS(_data["area"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Orphan();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["orphanID"] = this.orphanID;
        data["companyID"] = this.companyID;
        data["created"] = this.created;
        data["departed"] = this.departed;
        data["expires"] = this.expires;
        data["externalTransactionIdentification"] = this.externalTransactionIdentification;
        if (Array.isArray(this.vehicleIdents)) {
            data["vehicleIdents"] = [];
            for (let item of this.vehicleIdents)
                data["vehicleIdents"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        data["area"] = this.area ? this.area.toJSON() : undefined;
        return data;
    }
}
export class ParkingExistsContainer {
    exits;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["exits"])) {
                this.exits = [];
                for (let item of _data["exits"])
                    this.exits.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingExistsContainer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.exits)) {
            data["exits"] = [];
            for (let item of this.exits)
                data["exits"].push(item);
        }
        return data;
    }
}
export class ParkingOccupancyContainer {
    occupancy;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.occupancy = _data["occupancy"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingOccupancyContainer();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["occupancy"] = this.occupancy;
        return data;
    }
}
export class ParkingRight {
    transactions;
    parkingRightID;
    companyID;
    parkingRightSource;
    area;
    vehicleIdents;
    classification;
    customerInfo;
    purchased;
    validityBegin;
    parkingRightType;
    departed;
    sentToExternalCollection;
    latitude;
    longitude;
    reconciledTo;
    validityEnd;
    claimed;
    claimToken;
    externalUserIdentification;
    externalTerminalIdentification;
    externalTransactionIdentification;
    statisticalIdentifier;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [];
                for (let item of _data["transactions"])
                    this.transactions.push(TransactionSuccint.fromJS(item));
            }
            this.parkingRightID = _data["parkingRightID"];
            this.companyID = _data["companyID"];
            this.parkingRightSource = _data["parkingRightSource"];
            this.area = _data["area"] ? Area.fromJS(_data["area"]) : undefined;
            if (Array.isArray(_data["vehicleIdents"])) {
                this.vehicleIdents = [];
                for (let item of _data["vehicleIdents"])
                    this.vehicleIdents.push(Ident.fromJS(item));
            }
            this.classification = _data["classification"];
            this.customerInfo = _data["customerInfo"];
            this.purchased = _data["purchased"];
            this.validityBegin = _data["validityBegin"];
            this.parkingRightType = _data["parkingRightType"];
            this.departed = _data["departed"];
            this.sentToExternalCollection = _data["sentToExternalCollection"];
            this.latitude = _data["latitude"];
            this.longitude = _data["longitude"];
            this.reconciledTo = _data["reconciledTo"];
            this.validityEnd = _data["validityEnd"];
            this.claimed = _data["claimed"];
            this.claimToken = _data["claimToken"];
            this.externalUserIdentification = _data["externalUserIdentification"];
            this.externalTerminalIdentification = _data["externalTerminalIdentification"];
            this.externalTransactionIdentification = _data["externalTransactionIdentification"];
            this.statisticalIdentifier = _data["statisticalIdentifier"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new ParkingRight();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item.toJSON());
        }
        data["parkingRightID"] = this.parkingRightID;
        data["companyID"] = this.companyID;
        data["parkingRightSource"] = this.parkingRightSource;
        data["area"] = this.area ? this.area.toJSON() : undefined;
        if (Array.isArray(this.vehicleIdents)) {
            data["vehicleIdents"] = [];
            for (let item of this.vehicleIdents)
                data["vehicleIdents"].push(item.toJSON());
        }
        data["classification"] = this.classification;
        data["customerInfo"] = this.customerInfo;
        data["purchased"] = this.purchased;
        data["validityBegin"] = this.validityBegin;
        data["parkingRightType"] = this.parkingRightType;
        data["departed"] = this.departed;
        data["sentToExternalCollection"] = this.sentToExternalCollection;
        data["latitude"] = this.latitude;
        data["longitude"] = this.longitude;
        data["reconciledTo"] = this.reconciledTo;
        data["validityEnd"] = this.validityEnd;
        data["claimed"] = this.claimed;
        data["claimToken"] = this.claimToken;
        data["externalUserIdentification"] = this.externalUserIdentification;
        data["externalTerminalIdentification"] = this.externalTerminalIdentification;
        data["externalTransactionIdentification"] = this.externalTransactionIdentification;
        data["statisticalIdentifier"] = this.statisticalIdentifier;
        return data;
    }
}
export class PaymentInformation {
    origin;
    pricelist;
    paymentType;
    paymentMethod;
    paymentScheme;
    currency;
    price;
    vat;
    exponent;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.origin = _data["origin"];
            this.pricelist = _data["pricelist"];
            this.paymentType = _data["paymentType"];
            this.paymentMethod = _data["paymentMethod"];
            this.paymentScheme = _data["paymentScheme"];
            this.currency = _data["currency"];
            this.price = _data["price"];
            this.vat = _data["vat"];
            this.exponent = _data["exponent"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PaymentInformation();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["origin"] = this.origin;
        data["pricelist"] = this.pricelist;
        data["paymentType"] = this.paymentType;
        data["paymentMethod"] = this.paymentMethod;
        data["paymentScheme"] = this.paymentScheme;
        data["currency"] = this.currency;
        data["price"] = this.price;
        data["vat"] = this.vat;
        data["exponent"] = this.exponent;
        return data;
    }
}
export var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod[PaymentMethod["_10"] = 10] = "_10";
    PaymentMethod[PaymentMethod["_20"] = 20] = "_20";
    PaymentMethod[PaymentMethod["_30"] = 30] = "_30";
    PaymentMethod[PaymentMethod["_40"] = 40] = "_40";
    PaymentMethod[PaymentMethod["_50"] = 50] = "_50";
    PaymentMethod[PaymentMethod["_60"] = 60] = "_60";
    PaymentMethod[PaymentMethod["_70"] = 70] = "_70";
    PaymentMethod[PaymentMethod["_80"] = 80] = "_80";
    PaymentMethod[PaymentMethod["_90"] = 90] = "_90";
    PaymentMethod[PaymentMethod["_100"] = 100] = "_100";
    PaymentMethod[PaymentMethod["_110"] = 110] = "_110";
    PaymentMethod[PaymentMethod["_1000"] = 1000] = "_1000";
    PaymentMethod[PaymentMethod["_2000"] = 2000] = "_2000";
})(PaymentMethod || (PaymentMethod = {}));
export var PaymentType;
(function (PaymentType) {
    PaymentType[PaymentType["_0"] = 0] = "_0";
    PaymentType[PaymentType["_100"] = 100] = "_100";
    PaymentType[PaymentType["_200"] = 200] = "_200";
})(PaymentType || (PaymentType = {}));
export class Periods {
    from;
    to;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["from"])) {
                this.from = [];
                for (let item of _data["from"])
                    this.from.push(item);
            }
            if (Array.isArray(_data["to"])) {
                this.to = [];
                for (let item of _data["to"])
                    this.to.push(item);
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Periods();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.from)) {
            data["from"] = [];
            for (let item of this.from)
                data["from"].push(item);
        }
        if (Array.isArray(this.to)) {
            data["to"] = [];
            for (let item of this.to)
                data["to"].push(item);
        }
        return data;
    }
}
export class PrsTag {
    name;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new PrsTag();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["name"] = this.name;
        return data;
    }
}
export class SubArea {
    includedSubAreas;
    subAreaID;
    geographicalName;
    name;
    softLimit;
    hardLimit;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["includedSubAreas"])) {
                this.includedSubAreas = [];
                for (let item of _data["includedSubAreas"])
                    this.includedSubAreas.push(SubAreaInclusion.fromJS(item));
            }
            this.subAreaID = _data["subAreaID"];
            this.geographicalName = _data["geographicalName"];
            this.name = _data["name"];
            this.softLimit = _data["softLimit"];
            this.hardLimit = _data["hardLimit"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubArea();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        if (Array.isArray(this.includedSubAreas)) {
            data["includedSubAreas"] = [];
            for (let item of this.includedSubAreas)
                data["includedSubAreas"].push(item.toJSON());
        }
        data["subAreaID"] = this.subAreaID;
        data["geographicalName"] = this.geographicalName;
        data["name"] = this.name;
        data["softLimit"] = this.softLimit;
        data["hardLimit"] = this.hardLimit;
        return data;
    }
}
export class SubAreaInclusion {
    subAreaID;
    geographicalName;
    name;
    softLimit;
    hardLimit;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.subAreaID = _data["subAreaID"];
            this.geographicalName = _data["geographicalName"];
            this.name = _data["name"];
            this.softLimit = _data["softLimit"];
            this.hardLimit = _data["hardLimit"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new SubAreaInclusion();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["subAreaID"] = this.subAreaID;
        data["geographicalName"] = this.geographicalName;
        data["name"] = this.name;
        data["softLimit"] = this.softLimit;
        data["hardLimit"] = this.hardLimit;
        return data;
    }
}
export class TransactionSuccint {
    transactionID;
    externalTerminalIdentification;
    externalTransactionIdentification;
    externalUserIdentification;
    sellingPointID;
    sellingPointLocation;
    paymentInformation;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.transactionID = _data["transactionID"];
            this.externalTerminalIdentification = _data["externalTerminalIdentification"];
            this.externalTransactionIdentification = _data["externalTransactionIdentification"];
            this.externalUserIdentification = _data["externalUserIdentification"];
            this.sellingPointID = _data["sellingPointID"];
            this.sellingPointLocation = _data["sellingPointLocation"];
            this.paymentInformation = _data["paymentInformation"]
                ? PaymentInformation.fromJS(_data["paymentInformation"])
                : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new TransactionSuccint();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["transactionID"] = this.transactionID;
        data["externalTerminalIdentification"] = this.externalTerminalIdentification;
        data["externalTransactionIdentification"] = this.externalTransactionIdentification;
        data["externalUserIdentification"] = this.externalUserIdentification;
        data["sellingPointID"] = this.sellingPointID;
        data["sellingPointLocation"] = this.sellingPointLocation;
        data["paymentInformation"] = this.paymentInformation
            ? this.paymentInformation.toJSON()
            : undefined;
        return data;
    }
}
export var DayOfWeek;
(function (DayOfWeek) {
    DayOfWeek[DayOfWeek["_0"] = 0] = "_0";
    DayOfWeek[DayOfWeek["_1"] = 1] = "_1";
    DayOfWeek[DayOfWeek["_2"] = 2] = "_2";
    DayOfWeek[DayOfWeek["_3"] = 3] = "_3";
    DayOfWeek[DayOfWeek["_4"] = 4] = "_4";
    DayOfWeek[DayOfWeek["_5"] = 5] = "_5";
    DayOfWeek[DayOfWeek["_6"] = 6] = "_6";
})(DayOfWeek || (DayOfWeek = {}));
export class Dependency {
    status;
    responseTime;
    dependencies;
    type;
    name;
    version;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.status = _data["status"];
            this.responseTime = _data["responseTime"];
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [];
                for (let item of _data["dependencies"])
                    this.dependencies.push(Dependency.fromJS(item));
            }
            this.type = _data["type"];
            this.name = _data["name"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Dependency();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["status"] = this.status;
        data["responseTime"] = this.responseTime;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item.toJSON());
        }
        data["type"] = this.type;
        data["name"] = this.name;
        data["version"] = this.version;
        return data;
    }
}
export var DependencyStatus;
(function (DependencyStatus) {
    DependencyStatus[DependencyStatus["_0"] = 0] = "_0";
    DependencyStatus[DependencyStatus["_1"] = 1] = "_1";
    DependencyStatus[DependencyStatus["_2"] = 2] = "_2";
    DependencyStatus[DependencyStatus["_3"] = 3] = "_3";
})(DependencyStatus || (DependencyStatus = {}));
export class Ping {
    server;
    dependencies;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.server = _data["server"] ? Server.fromJS(_data["server"]) : undefined;
            if (Array.isArray(_data["dependencies"])) {
                this.dependencies = [];
                for (let item of _data["dependencies"])
                    this.dependencies.push(Dependency.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Ping();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["server"] = this.server ? this.server.toJSON() : undefined;
        if (Array.isArray(this.dependencies)) {
            data["dependencies"] = [];
            for (let item of this.dependencies)
                data["dependencies"].push(item.toJSON());
        }
        return data;
    }
}
export class Server {
    type;
    name;
    version;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.name = _data["name"];
            this.version = _data["version"];
        }
    }
    static fromJS(data) {
        data = typeof data === "object" ? data : {};
        let result = new Server();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === "object" ? data : {};
        data["type"] = this.type;
        data["name"] = this.name;
        data["version"] = this.version;
        return data;
    }
}
export class ApiException extends Error {
    message;
    status;
    response;
    headers;
    result;
    constructor(message, status, response, headers, result) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    isApiException = true;
    static isApiException(obj) {
        return obj.isApiException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}
function isAxiosError(obj) {
    return obj && obj.isAxiosError === true;
}
